<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>门店管理</el-breadcrumb-item>
            <el-breadcrumb-item>门店列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-input placeholder="请输入门店名称/门店序号" clearable v-model="queryInfo.query" @clear="handleQuery()" @keyup.enter.native="handleQuery()">
                        <el-button slot="append" icon="el-icon-search" @click="handleQuery()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="6">
                    <el-select  v-model="queryInfo.query1" clearable  placeholder="请选择门店状态" @change="getList()"  style="margin-right:10px">
                            <el-option label="营业" value="1"></el-option>
                            <el-option label="关闭" value="2"></el-option>
                            <el-option label="装修中" value="3"></el-option>
                            <el-option label="歇业中" value="4"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <el-select  v-model="queryInfo.skType" clearable  placeholder="请选择收款类型" @change="getList()"  style="margin-right:10px">
                            <el-option label="总部商户" value="0"></el-option>
                            <el-option label="子商户" value="1"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <el-select  v-model="queryInfo.newDevice" clearable  placeholder="请选择设备类型" @change="getList()"  style="margin-right:10px">
                            <el-option label="新设备" value="Y"></el-option>
                            <el-option label="旧设备" value="N"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <el-select v-model="queryInfo.lockStatus" clearable placeholder="锁定状态" @change="getList()" style="margin-right:10px">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="已锁定" value="1"></el-option>
                        <el-option label="未锁定" value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <el-input placeholder="请输入城市/地址" clearable v-model="queryInfo.query2" @clear="handleQuery()">
                        <el-button slot="append" icon="el-icon-search" @click="handleQuery()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="6">
                    <el-button type="primary" @click="AddStore" v-permission="'btn:store:add'">添加门店</el-button>
                    <el-button type="primary" @click="SetBath" v-permission="'btn:store:bath:test'">淋浴测试帐号</el-button>
                    <el-button type="success" @click="ExportStore" v-permission="'btn:store:export'">导出门店</el-button>
                    <el-button type="warning" icon="el-icon-connection" @click="SetMeiTuan('', '59')" v-permission="'btn:store:meituan'" v-if="!ismeituan59">进行授权</el-button>
                    <el-button type="danger" icon="el-icon-connection" @click="SetMeiTuan('', '59')" v-permission="'btn:store:meituan'" v-else>重新授权</el-button>
                </el-col>
                <el-col :span="6">
                    <el-button type="primary" @click="openStoreOwnerManager" v-permission="'btn:store:owner:manage'" icon="el-icon-user-solid">门店人员管理</el-button>
                    <el-button type="success" @click="syncToKnowledgeBase" icon="el-icon-upload2" :loading="syncLoading">同步到知识库</el-button>
                </el-col>
                <el-col :span="6" style="text-align: right;font-size: 12px;color:#999;line-height: 30px;">( *店名红色的是虚拟门店 )</el-col>
                <!-- 注释掉在线人数显示 -->
                <!-- <el-col :span="6" style="text-align: right;font-size: 12px;line-height: 30px;">在线人数：{{allPeople}}</el-col> -->
            </el-row>
            <br>
            <!--搜索与添加区域-->
            <!--商品列表区域-->
            <el-table :data="list" style="width: 100%" v-loading="tableLoading" stripe size="middle" border height="700">
                <!-- <el-table-column label="ID" type="index"  fixed></el-table-column> -->
                 <el-table-column label="门店ID" prop="id"  fixed></el-table-column>
<!--                <el-table-column label="序号" width="50" fixed align="center">-->
<!--                    <template slot-scope="scope">-->
<!--                        {{ (queryInfo.pagenum - 1) * queryInfo.pagesize + scope.$index + 1 }}-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column label="门店序号" prop="xh" width="100" fixed align="center"></el-table-column>
                <el-table-column label="门店名称" prop="storename" width="250" show-overflow-tooltip fixed align="center">
                    <template slot-scope="scope">
                        <span :style="{ color: scope.row.ismock == '1' ? 'red' : 'black' }">
                            {{ scope.row.storename }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="所属城市" prop="cityid" width="200" align="center">
                    <template slot-scope="scope">
                        {{scope.row.city}} {{scope.row.county}}
                    </template>
                </el-table-column>
                <!-- <el-table-column label="门店图片" prop="storepic" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.storepic">
                            <el-popover placement="bottom"  width="600" trigger="click">
                                <div style="text-align: center;">
                                <img :src="imgURL+'static/pics/'+scope.row.storepic"  style="width:600px"/>
                                </div>
                                <img  slot="reference" :src="imgURL+'static/pics/'+scope.row.storepic" style="width:30px">
                            </el-popover>
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column label="门店地址" prop="address" width="200" show-overflow-tooltip align="center"/>
              <el-table-column label="设备类型" prop="newFlag" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.newFlag === 'Y'">新</el-tag>
                  <el-tag type="info" v-else>旧</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="人脸类型" prop="faceLocal" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.faceLocal === 'Y'">本地</el-tag>
                  <el-tag type="info" v-else>线上</el-tag>
                </template>
              </el-table-column>
                <!-- 注释掉在线人数列 -->
                <!-- <el-table-column label="在线人数" prop="curPeople" width="150" align="center"></el-table-column> -->
                <el-table-column label="电话" prop="telephone" width="150" align="center"></el-table-column>
                <!-- <el-table-column label="经纬度" prop="sn" width="200">
                    <template slot-scope="scope">
                        {{ scope.row.lat }}--{{ scope.row.long }}
                    </template>
                </el-table-column> -->
                <el-table-column label="进店1Sn" prop="sn" width="100" align="center"/>
                <el-table-column label="出店1Sn" prop="outsn" width="100" align="center"/>
                <el-table-column label="进店2Sn" prop="sn1" width="100" align="center"/>
                <el-table-column label="出店2Sn" prop="outsn1" width="100" align="center"/>
                <el-table-column label="鱼眼摄像头1Sn" prop="fishsn" width="220" align="center"/>
                <el-table-column label="鱼眼摄像头2Sn" prop="fishsn1" width="220" align="center"/>
                <el-table-column label="摄像头1Sn" prop="camera1" width="190" align="center"/>
                <el-table-column label="摄像头2Sn" prop="camera2" width="190" align="center"/>
                <el-table-column label="摄像头3Sn" prop="camera3" width="190" align="center"/>
                <el-table-column label="摄像头4Sn" prop="camera3" width="190" align="center"/>
                <el-table-column label="边缘盒子Sn" prop="boxsn" width="190" align="center"/>
                <el-table-column label="温湿度Sn" prop="wsdsn" width="250" align="center"/>
                <el-table-column label="上位机TOPIC" prop="upDeviceTopic" width="150" align="center"/>
                <el-table-column label="淋浴IP" prop="lyIp" width="150" align="center"/>
                <el-table-column label="操房数量" prop="roomnum" width="100" align="center">
                    <template slot-scope="scope">
                        {{scope.row.roomnum}} 间
                    </template>
                </el-table-column>
                <el-table-column label="门店面积" prop="storearea" width="100" align="center">
                    <template slot-scope="scope">
                        {{scope.row.storearea}}  ㎡
                    </template>
                </el-table-column>
<!--                <el-table-column label="器械种类" prop="devicetype" width="100" align="center">
                    <template slot-scope="scope">
                        {{scope.row.devicetype}}  种
                    </template>
                </el-table-column>-->
                <el-table-column label="微信" prop="wechat" width="150" align="center"></el-table-column>
                <el-table-column label="Wifi" prop="wifi" width="150" align="center"></el-table-column>
                <el-table-column label="抖音门店ID" prop="dystoreid" width="180" align="center"></el-table-column>
                <el-table-column label="高德门店ID" prop="gaodestoreid" width="180" align="center"></el-table-column>
                <el-table-column label="加盟时间" prop="adddate" width="180" align="center"></el-table-column>
              <el-table-column label="点歌二维码" width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.path">
                    <el-popover placement="bottom"  width="600" trigger="click">
                      <div style="text-align: center;">
                        <img :src="imgURL+scope.row.path"  style="width:600px"/>
                      </div>
                      <img :src="imgURL+scope.row.path" style="width:50px" slot="reference">
                    </el-popover>
                  </div>
                  <span v-else>无</span>
                </template>
              </el-table-column>
                <el-table-column label="收款帐户" prop="issub" width="120" fixed="right" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.issub == '0'">总部商户</span>
                        <span v-else>{{ scope.row.submchid }}</span>

                    </template>
                </el-table-column>
                <el-table-column label="营业状态" width="100" fixed="right" align="center">
                    <template slot-scope="scope">
                       <el-tag v-if="scope.row.isTy=='1'"  type="danger">停业</el-tag>
                       <el-tag v-else type="success">正常</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="isopen" width="100" fixed="right" align="center">
                    <template slot-scope="scope">
                       <el-tag v-if="scope.row.isopen=='1'"  type="success">营业</el-tag>
                       <el-tag v-else-if="scope.row.isopen=='2'" type="info">关闭</el-tag>
                       <el-tag v-else-if="scope.row.isopen=='3'" type="warning">装修中</el-tag>
                       <el-tag v-else-if="scope.row.isopen=='4'" type="warning">歇业中</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="AB门逻辑" prop="doorLj" width="120" fixed="right" align="center">
                    <template slot-scope="scope">
                       <el-tag v-if="scope.row.doorLj=='N'"  type="success">旧逻辑</el-tag>
                       <el-tag v-else-if="scope.row.doorLj=='Y'" type="info">新逻辑</el-tag>
                       <el-tag v-else>-</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="虚拟" prop="ismock" width="80"  fixed="right" align="center">
                    <template  slot-scope="scope">
                        <el-switch active-value="1" inactive-value="0" v-model="scope.row.ismock" @change="SetMock(scope.row.id,scope.row.ismock)" v-permission="'btn:store:mock'"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="美团授权" width="80"  fixed="right" align="center">
                    <template  slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="进行授权" placement="top" v-if="!scope.row.ismeituan">
                        <el-button type="warning" icon="el-icon-connection" size="mini" @click="SetMeiTuan(scope.row.id, '58')" v-permission="'btn:store:meituan'"></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="重新授权" placement="top" v-else>
                        <el-button type="danger" icon="el-icon-connection" size="mini" @click="SetMeiTuan(scope.row.id, '58')" v-permission="'btn:store:meituan'"></el-button>
                      </el-tooltip>
<!--                      <el-tooltip class="item" effect="dark" content="取消授权" placement="top" v-else>-->
<!--                        <el-button type="danger" icon="el-icon-connection" size="mini" @click="DelMeiTuan(scope.row.id)" v-permission="'btn:store:unmeituan'"></el-button>-->
<!--                      </el-tooltip>-->
                    </template>
                </el-table-column>
                <!-- 注释掉人数列 -->
                <!--
                <el-table-column label="人数" prop="count" width="80"  fixed="right" align="center">
                    <template  slot-scope="scope">
                        {{ scope.row.count }} 人
                    </template>
                </el-table-column>
                -->
                <el-table-column label="操作" width="360" fixed="right" align="center">
                    <!--作用域插槽-->
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="标注门店" placement="top">
                            <el-button type="warning" icon="el-icon-location" size="mini" @click="MarkStore(scope.row.id)" v-permission="'btn:store:mark'"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="修改信息" placement="top">
                            <el-button type="success" icon="el-icon-edit" size="mini" @click="EditStore(scope.row.id)" v-permission="'btn:store:edit'"></el-button>
                        </el-tooltip>
                        <!-- <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelStore(scope.row.id)"></el-button> -->
                        <el-tooltip class="item" effect="dark" content="设置门店成员" placement="top">
                            <el-button type="danger" icon="el-icon-user-solid" size="mini" @click="SetBoss(scope.row)" v-permission="'btn:store:boss'"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="设置提现用户" placement="top" v-if="scope.row.bfId">
                            <el-button type="danger" icon="el-icon-s-finance" size="mini" @click="SetTxUser(scope.row)" v-permission="'btn:store:tx'"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="设置收款商户及扣点" placement="top">
                            <el-button type="primary" icon="el-icon-s-tools" size="mini" @click="Setting(scope.row.id)" v-permission="'btn:store:merchant'"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="设置空调SN" placement="top">
                            <el-button type="warning" icon="el-icon-switch-button" size="mini" @click="SetAirNew(scope.row)" v-permission="'btn:store:air'" v-if="scope.row.newFlag === 'Y'"></el-button>
                            <el-button type="warning" icon="el-icon-switch-button" size="mini" @click="SetAir(scope.row.id)" v-permission="'btn:store:air'" v-else></el-button>
                        </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="设备状态" placement="top" v-if="scope.row.newFlag === 'Y'">
                        <el-button type="warning" icon="el-icon-s-order" size="mini" @click="openDeviceStatus(scope.row)" v-permission="'btn:store:deviceStatus'"></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="点歌" placement="top" v-if="scope.row.musicTopic">
                        <el-button type="primary" icon="el-icon-mic" size="mini" @click="playMusic(scope.row)"></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="广播任务" placement="top" v-if="scope.row.musicTopic">
                        <el-button type="primary" icon="el-icon-microphone" size="mini" @click="playDsMusic(scope.row)"></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="播放计划" placement="top" v-if="scope.row.musicTopic">
                        <el-button type="primary" icon="el-icon-headset" size="mini" @click="openPlayTaskDialog(scope.row)"></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="延长会员卡天数" placement="top">
                        <el-button type="success" icon="el-icon-time" size="mini" @click="openExtendCardsDialog(scope.row)" v-permission="'btn:store:extend:cards'"></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="锁定门店" placement="top" v-if="scope.row.isLocked != 1">
                        <el-button type="warning" icon="el-icon-lock" size="mini" @click="lockStore(scope.row.id)" v-permission="'btn:store:lock'"></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="解锁门店" placement="top" v-if="scope.row.isLocked == 1">
                        <el-button type="success" icon="el-icon-unlock" size="mini" @click="unlockStore(scope.row.id)" v-permission="'btn:store:unlock'"></el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="邀请分享设置" placement="top" v-permission="'btn:store:share:setting'">
                        <el-button type="primary" icon="el-icon-share" size="mini" @click="openShareSetting(scope.row)"></el-button>
                      </el-tooltip>
                        <!-- <el-tooltip class="item" effect="dark" content="进门开关" placement="top" v-permission="'btn:store:door'">
                            <el-button type="success" icon="el-icon-lock" size="mini" @click="openDoor(scope.row.sn, scope.row.upDeviceTopic,
                             scope.row.faceLocal)"></el-button>
                        </el-tooltip>
                         <el-tooltip class="item" effect="dark" content="设置开卡时间" placement="top" v-permission="'btn:store:door'">
                            <el-button type="success" icon="el-icon-lock" size="mini" @click="openCardDays(scope.row)"></el-button>
                        </el-tooltip> -->
                    </template>
                </el-table-column>
            </el-table>
          <!--商品列表区域-->
          <!--分页区域-->
          <br>
          <div align="center">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="queryInfo.pagenum" :page-sizes="[20,50,500,1000]"  :page-size="queryInfo.pagesize"
              layout="total, sizes, prev, pager, next" :total="total">
              </el-pagination>
          </div>
          <!--分页区域-->
          <!--设置店主对话框-->
<!--          <el-dialog title="设置店主" :visible.sync="setDialogVisible" width="50%" @close="setDialogClosed">-->
<!--              <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px" class="demo-dynamic">-->
<!--                  <el-form-item-->
<!--                      v-for="(owner, index) in dynamicValidateForm.owners"-->
<!--                      :label="'店主' + (index + 1)"-->
<!--                      :key="owner.key"-->
<!--                      :prop="'owners.' + index + '.username'"-->
<!--                      :rules="[{ required: true, message: '店主不能为空', trigger: 'blur' },-->
<!--                      { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }]"-->
<!--                  >-->
<!--                      <div class="owner-row">-->
<!--                        <div class="owner-main-line">-->
<!--                          <el-input v-model="owner.username" placeholder="请输入店主手机号" class="owner-phone-input" @blur="checkOwnerAuth(index)"></el-input>-->

<!--                          <el-button type="text" size="small" @click.prevent="removeOwner(owner)" class="owner-delete-btn"><i class="el-icon-close"></i> 删除</el-button>-->
<!--                        </div>-->
<!--                        <div v-if="owner.authStatus === 2" class="owner-auth-line">-->
<!--                          <span class="owner-auth-chip">-->
<!--                            <span class="auth-chip-label">姓名</span>-->
<!--                            <span class="auth-chip-value">{{ owner.realName }}</span>-->
<!--                            <span class="auth-chip-divider">|</span>-->
<!--                            <span class="auth-chip-label">身份证</span>-->
<!--                            <span class="auth-chip-value">{{ owner.idcard }}</span>-->
<!--                          </span>-->
<!--                          <el-button type="text" size="small" @click="clearOwnerAuthByUsername(owner.username)" class="clear-auth-btn">-->
<!--                            <i class="el-icon-delete"></i> 清除实名-->
<!--                          </el-button>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                  </el-form-item>-->
<!--              </el-form>-->
<!--              <span slot="footer" class="dialog-footer">-->
<!--                  <el-button @click="addOwner" v-permission="'btn:store:boss:add'">新增店主</el-button>-->
<!--                  <el-button type="primary" @click="submitForm('dynamicValidateForm')" v-permission="'btn:store:boss:save'">提交</el-button>-->
<!--              </span>-->
<!--          </el-dialog>-->
          <!--设置店主对话框-->
          <!--设置店主对话框-->
          <el-dialog title="设置门店人员" :visible.sync="setDialogVisible" width="50%" @close="setDialogClosed">
              <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px" class="demo-dynamic">
                  <el-form-item
                      v-for="(owner, index) in dynamicValidateForm.owners"
                      :label="'人员' + (index + 1)"
                      :key="owner.key"
                      :prop="'owners.' + index + '.username'"
                      :rules="[{ required: true, message: '店主不能为空', trigger: 'blur' },
                      { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }]"
                  >
                    <el-row :gutter="10">
                      <el-col :span="10">
                        <el-input v-model="owner.username" placeholder="请输入店主手机号" class="owner-phone-input" @blur="checkOwnerAuth(index)"></el-input>
                      </el-col>
                      <el-col :span="10">
                        <el-select  v-model="owner.roleKeys" multiple @change="filterRole" placeholder="请选择角色"  style="margin-right:10px">
                          <el-option v-for="user in owner.roleList" :label="user.roleName" :value="user.roleKey"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="4">
                        <el-button type="text" size="small" @click.prevent="removeOwner(owner)" class="owner-delete-btn"><i class="el-icon-close"></i> 删除</el-button>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10" v-if="owner.menuList.indexOf('tx') > -1">
                      <el-col :span="5">
                        <el-form-item label="提现状态">
                          <el-switch active-value="1" inactive-value="0" v-model="owner.istx"></el-switch>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-form-item label="需要审核">
                          <el-switch active-value="1" inactive-value="0" v-model="owner.isaudit"></el-switch>
                        </el-form-item>
                      </el-col>
                    </el-row>
                      <div class="owner-row">
                        <div v-if="owner.authStatus === 2" class="owner-auth-line">
                          <span class="owner-auth-chip">
                            <span class="auth-chip-label">姓名</span>
                            <span class="auth-chip-value">{{ owner.realName }}</span>
                            <span class="auth-chip-divider">|</span>
                            <span class="auth-chip-label">身份证</span>
                            <span class="auth-chip-value">{{ owner.idcard }}</span>
                          </span>
                          <el-button type="text" size="small" @click="clearOwnerAuthByUsername(owner.username)" class="clear-auth-btn">
                            <i class="el-icon-delete"></i> 清除实名
                          </el-button>
                        </div>
                      </div>
                  </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="addOwner" v-permission="'btn:store:boss:add'">新增店主</el-button>
                  <el-button type="primary" @click="submitForm('dynamicValidateForm')" v-permission="'btn:store:boss:save'">提交</el-button>
              </span>
          </el-dialog>
          <!--设置店主对话框-->
          <!--设置提现用户对话框-->
          <el-dialog title="设置提现用户" :visible.sync="setDialogVisibleTx" width="50%" @close="setDialogTxClosed">
              <el-form :model="dynamicValidateTxForm" ref="dynamicValidateTxForm" label-width="100px" class="demo-dynamic">
                  <el-form-item
                      label="门店"
                  >
                  {{dynamicValidateTxForm.storename}}
                  </el-form-item>
                <el-row :gutter="10" v-for="(user,index) in dynamicValidateTxForm.users" :key="index">
                  <el-col :span="11">
<!--                      <el-form-item-->
<!--                          label="提现用户"-->
<!--                          :prop="'users.'+index+'.username'"-->
<!--                          :rules="[{required: true, message: '提现用户不能为空', trigger: 'blur'},-->
<!--                          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }]"-->
<!--                      >-->
<!--                        <el-input v-model="user.username" placeholder="请输入提现用户手机号" style="width: 100%;"></el-input>-->
<!--                      </el-form-item>-->
                    <el-form-item
                        label="提现用户"
                        :prop="'users.'+index+'.username'"
                        :rules="[{required: true, message: '提现用户不能为空', trigger: 'blur'}]">
                      <el-select v-model="user.username" clearable filterable placeholder="请选择提现用户" style="width: 100%;">
                        <el-option :label="mainer.username" :value="mainer.username" :disabled="mainer.disable" v-for="mainer in storeMainers"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="提现状态">
                      <el-switch active-value="1" inactive-value="0" v-model="user.istx"></el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="需要审核">
                      <el-switch active-value="1" inactive-value="0" v-model="user.isaudit"></el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-button type="danger" icon="el-icon-delete" circle @click="handleDelUser(index)"></el-button>
                  </el-col>
                </el-row>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="handleAddUser">新增用户</el-button>
                  <el-button type="primary" @click="submitTxForm()" v-permission="'btn:store:tx:save'">提交</el-button>
              </span>
          </el-dialog>
          <!--设置店主对话框-->
          <!-- 设置商户及扣点 -->
          <el-dialog title="设置商户及扣点" :visible.sync="settingDialogVisible" width="70%" @close="settingDialogClosed">
              <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="120px" style="padding: 10px;">
                  <el-form-item label="店名" prop="storename">
                      <el-input v-model="editForm.storename" readonly></el-input>
                  </el-form-item>
                  <el-form-item label="欠设备款" prop="alarm">
                      <el-input v-model="editForm.alarm" type="number" :min="1">
                          <template slot="append">元</template>
                      </el-input>
                  </el-form-item>
                  <el-form-item label="扣点" prop="points">
                      <el-input v-model="editForm.points">
                          <template slot="append">(例：0.05)</template>
                      </el-input>
                  </el-form-item>
                  <el-form-item label="代账发卡扣点" prop="agencyPoints">
                      <el-input v-model="editForm.agencyPoints" placeholder="请输入代账发卡扣点">
                          <template slot="append">(例：0.05)</template>
                      </el-input>
                  </el-form-item>
                  <el-form-item label="子商户收款" prop="issub">
                      <el-switch :active-value="'1'" :inactive-value="'0'" v-model="editForm.issub" @change="ChangeSub"></el-switch>
                  </el-form-item>
                  <el-form-item label="商户号" prop="submchid" v-if="editForm.issub === '1'">
                      <el-input v-model="editForm.submchid"></el-input>
                  </el-form-item>
                  <el-form-item label="分账" prop="submchid" v-if="editForm.issub === '1'">
                    <el-switch :active-value="'1'" :inactive-value="'0'" v-model="editForm.isfz"></el-switch>
                  </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="settingDialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="SettingSave" v-permission="'btn:store:merchant:save'">确 定</el-button>
              </span>
          </el-dialog>
          <!-- 设置商户及扣点 -->
           <!-- 沐浴测试帐号 -->
          <el-dialog title="沐浴测试帐号" :visible.sync="bathDialogVisible" width="50%" @close="bath_username=''">
              <el-input placeholder="请输入内容手机号" v-model="bath_username" style="width: 40%;">
                  <el-button slot="append" @click="AddBath" v-permission="'btn:store:bath:add'">添加</el-button>
              </el-input>
              <el-table :data="bathlist" style="width: 100%;" height="500" stripe size="middle">
                  <el-table-column label="ID" type="index" align="center"></el-table-column>
                  <el-table-column label="手机号" prop="username" width="150" align="center"></el-table-column>
                  <el-table-column label="Openid" prop="openid" width="300" align="center"></el-table-column>
                  <el-table-column label="添加日期" prop="adddate" width="300" align="center"></el-table-column>
                  <el-table-column label="删除" align="center">
                      <template slot-scope="scope">
                          <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelBath(scope.row.username)" v-permission="'btn:store:bath:delete'"></el-button>
                      </template>
                  </el-table-column>
              </el-table>
          </el-dialog>
          <!-- 沐浴测试帐号 -->
          <!-- 设置空调SN -->
          <el-dialog title="设置空调远红外控制" :visible.sync="ariDialogVisible" width="50%" @close="code=''">
                <div style="display: flex;justify-content: space-between;height: 300px;">
                    <div style="overflow-y: auto;flex: 1">
                      <el-button type="primary" @click="handleAddWg">添加网关</el-button>
                      <el-table :data="airForm" stripe @row-click="handleWgClick">
                        <el-table-column prop="gateway" label="网关MAC/TOPIC" width="180"/>
                        <el-table-column label="类型" width="100">
                          <template slot-scope="scope">
                            <el-tag type="success" v-if="scope.row.type == '1'">商用</el-tag>
                            <el-tag type="primary" v-else>普通</el-tag>
                          </template>
                        </el-table-column>
                        <el-table-column label="操作">
                          <template slot-scope="scope">
                            <el-button type="primary" v-if="scope.row.type == '1'" @click="handleAddDevice(scope.row.gateway)">添加设备</el-button>
                            <el-button type="danger" @click="handleDelWg(scope.row.gateway)">删除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>

                    <div style="margin-left:10px; flex:1; border-left: 1px dashed #ccc;" v-if="gatewar">
                      <el-button type="primary" @click="handleAddAirDevice" v-if="wgType !== '1'">添加设备</el-button>
                      <el-table :data="airDevice" stripe style="width: 100%">
                        <el-table-column type="index" label="序号" width="100"/>
                        <el-table-column prop="far" label="地址"/>
                        <el-table-column label="是否匹配" width="100">
                          <template slot-scope="scope">
                            <el-tag type="danger" v-if="scope.row.ifPp == 'N'">否</el-tag>
                            <el-tag type="primary" v-else>是</el-tag>
                          </template>
                        </el-table-column>
                        <el-table-column label="操作" width="200">
                          <template slot-scope="scope">
                            <el-button type="primary" v-if="scope.row.ifPp == 'N'" @click="handlePpDevice(scope.row)">匹配</el-button>
                            <el-button type="danger" @click="handleDelDevice(scope.row.id)">删除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                </div>
            </el-dialog>

          <el-dialog title="添加网关" :visible.sync="wgAddFlag" width="50%">
            <el-form ref="wgForm" :model="wgForm" :rules="wgRules" label-width="110px">
              <el-form-item label="网关类型" prop="wgType">
                <el-radio-group v-model="wgForm.type">
                  <el-radio label="0">普通</el-radio>
                  <el-radio label="1">商用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="wgForm.type == '1' ? 'ESP32_MAC' : '网关主题'" prop="gateway">
                <el-input v-model="wgForm.gateway" :placeholder="wgForm.type == '1' ? '请输入ESP32_MAC' : '请输入网关主题'" @blur="handleTopicBlur"/>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="submitWgForm" v-loading="btnLoading">确定</el-button>
              <el-button @click="wgAddFlag = false">取 消</el-button>
            </div>
          </el-dialog>

          <el-dialog title="添加空调设备" :visible.sync="airDevAddFlag" width="50%">
            <el-form ref="airDevForm" :model="airDevForm" :rules="airDevRules" label-width="110px">
              <el-form-item label="设备地址" prop="far">
                <el-input v-model="airDevForm.far" placeholder="请输入设备地址"/>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="submitAirDevForm" v-loading="btnLoading">确定</el-button>
              <el-button @click="airDevAddFlag = false">取 消</el-button>
            </div>
          </el-dialog>

          <!-- 匹配设备对话框 -->
          <el-dialog title="匹配空调" :visible.sync="openPp" width="500px" append-to-body>
            <el-form ref="formPp" :model="ppForm" :rules="ppRules" label-width="80px">
              <el-form-item label="匹配方式">
                <el-radio-group v-model="ppForm.ppMethod" @change="handlePpMethodChange">
                  <el-radio
                      label="0"
                  >自动</el-radio>
                  <el-radio
                      label="1"
                  >手动</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="品牌" prop="brand" v-if="ppForm.ppMethod === '1'">
                <el-select v-model="kfidStr" filterable placeholder="请选择品牌" clearable @change="handleBrandChange">
                  <el-option
                      v-for="dict in brandArr"
                      :key="dict.kfid"
                      :label="dict.brand"
                      :value="dict.kfid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="subMitPpForm">开始匹配</el-button>
              <el-button @click="openPp = false">取 消</el-button>
            </div>
          </el-dialog>
          <!-- 手动匹配对话框 -->
          <el-dialog title="手动匹配" :visible.sync="openSdPp" width="500px" append-to-body :close-on-click-modal="false">
            <el-form label-width="80px">
              <el-form-item label="品牌">
                {{ppForm.brand}}
              </el-form-item>
              <el-form-item label="当前数量">
                {{kfidIndex + 1}} / {{kfidArr.length - 1}}
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="openDevice('1')">设备开</el-button>
              <el-button type="primary" @click="openDevice('0')">设备关</el-button>
              <el-button @click="nextBrand">下一个</el-button>
            </div>
          </el-dialog>

          <!-- 设置空调(新设备) -->
          <el-dialog title="设置空调设备" :visible.sync="ariDialogVisibleNew" width="80%" @close="code=''">
              <el-button @click="addAirManager" type="primary" style="margin-bottom: 10px">新增控制设备</el-button>
              <el-card class="box-card" style="margin-bottom: 10px" :key="index" v-for="(o,index) in airFormNew">
                <div slot="header" class="clearfix">
                  <span>空调控制器{{index + 1}}</span>
                  <el-button style="float: right;top: -11px; position: relative;" @click="handleDelAirManager(index)" type="danger" icon="el-icon-delete" circle></el-button>
                </div>
                <el-form :inline="true">
                  <el-row :gutter="10" >
                    <el-col :span="16">
                      <el-row :gutter="10">
                        <el-col :span="12">
                          <el-form-item label="设备地址">
                            <el-input v-model="o.path" @change="handleAlterPath(index)" :maxlength="2"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="控制器类型">
                            <el-radio-group v-model="o.airType" :disabled="o.id != null" @change="handleAirTypeChange(o,index)">
                              <el-radio
                                  v-for="dict in airTypes"
                                  :key="dict.value"
                                  :label="dict.value"
                              >{{dict.label}}</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8" v-if="o.airType === '0' || o.airType === '2'">
                      <el-button @click="addAir(index)" type="primary" style="float: right">新增设备</el-button>
                    </el-col>
                  </el-row>
                </el-form>
                <el-table :data="o.data" height="250" border style="width: 100%" v-if="o.airType === '0' || o.airType === '2'">
                  <el-table-column type="index" label="序号" width="100" align="center"/>
                  <el-table-column prop="name" label="名称" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.name"  style="width:100%"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="port" label="设备" align="center" v-if="o.airType === '0'">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.port" @change="handleAlterPath(index, scope.$index)" clearable placeholder="请选择">
                        <el-option
                            v-for="item in filterPort(scope.row.port, o.data)"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="port" label="内机地址" align="center" v-else>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.port" @blur="handleZPath(index, scope.$index)" :maxlength="4" style="width:100%"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="autoFlag" label="自动运行" align="center">
                    <template slot-scope="scope">
                      <el-switch
                          onchange="handleAutoChange(scope.row, index, scope.$index)"
                          v-model="scope.row.autoFlag"
                          active-color="#13ce66"
                          inactive-color="#ff4949"
                          active-value="1"
                          inactive-value="0">
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column prop="autoFlag" label="自动类型" align="center">
                    <template slot-scope="scope">
                      <el-radio-group @change="handleAutoTypeChange(scope.row, index, scope.$index)" v-model="scope.row.autoType" v-if="scope.row.autoFlag === '1'">
                        <el-radio :label="'0'">定时</el-radio>
                        <el-radio :label="'1'">系统</el-radio>
                      </el-radio-group>
                    </template>
                  </el-table-column>
                  <el-table-column label="开始时间" align="center" width="300">
                    <template slot-scope="scope">
                      <el-time-picker
                          v-if="scope.row.autoType === '0'"
                          v-model="scope.row.startTime"
                          placeholder="开始时间">
                      </el-time-picker>
                    </template>
                  </el-table-column>
                  <el-table-column label="结束时间" align="center" width="300">
                    <template slot-scope="scope">
                      <el-time-picker
                          v-if="scope.row.autoType === '0'"
                          v-model="scope.row.endTime"
                          placeholder="结束时间">
                      </el-time-picker>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ifPp" label="是否匹配" align="center" width="100">
                    <template slot-scope="scope">
                      <el-tag type="danger" v-if="scope.row.ifPp === 'N'">否</el-tag>
                      <el-tag v-else>是</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="openFlag" label="状态" align="center" width="100">
                    <template slot-scope="scope">
                      <el-tag type="danger" v-if="scope.row.openFlag === 'N'">关</el-tag>
                      <el-tag v-else>开</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="scope">
                      <el-button @click="ppAir(index, scope.$index)" v-if="scope.row.ifPp === 'N' && o.airType === '0'">匹配</el-button>
                      <el-button type="primary" @click="delAir(index, scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table :data="o.data" height="250" border style="width: 100%" v-else>
                  <el-table-column type="index" label="序号" width="100" align="center"/>
                  <el-table-column prop="name" label="名称" align="center">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.name"  style="width:100%"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="autoFlag" label="自动运行" align="center">
                    <template slot-scope="scope">
                      <el-switch
                          onchange="handleAutoChange(scope.row, index, scope.$index)"
                          v-model="scope.row.autoFlag"
                          active-color="#13ce66"
                          inactive-color="#ff4949"
                          active-value="1"
                          inactive-value="0">
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column prop="autoFlag" label="自动类型" align="center">
                    <template slot-scope="scope">
                      <el-radio-group @change="handleAutoTypeChange(scope.row, index, scope.$index)" v-model="scope.row.autoType" v-if="scope.row.autoFlag === '1'">
                        <el-radio :label="'0'">定时</el-radio>
                        <el-radio :label="'1'">系统</el-radio>
                      </el-radio-group>
                    </template>
                  </el-table-column>
                  <el-table-column label="开始时间" align="center" width="300">
                    <template slot-scope="scope">
                      <el-time-picker
                          v-if="scope.row.autoType === '0'"
                          v-model="scope.row.startTime"
                          placeholder="开始时间">
                      </el-time-picker>
                    </template>
                  </el-table-column>
                  <el-table-column label="结束时间" align="center" width="300">
                    <template slot-scope="scope">
                      <el-time-picker
                          v-if="scope.row.autoType === '0'"
                          v-model="scope.row.endTime"
                          placeholder="结束时间">
                      </el-time-picker>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ifPp" label="是否匹配" align="center" width="100">
                    <template slot-scope="scope">
                      <el-tag type="danger" v-if="scope.row.ifPp === 'N'">否</el-tag>
                      <el-tag v-else>是</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>

              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAirFormNew" v-loading="btnLoading">确 定</el-button>
                <el-button @click="ariDialogVisibleNew = false">取 消</el-button>
              </div>
            </el-dialog>
          <!-- 设置空调SN -->
          <!-- 空调操控(新设备) -->
          <el-dialog title="设置空调设备" :visible.sync="ariOperatorDialogVisibleNew" width="50%" @close="code=''">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-button @click="operatorAir('open')" type="primary" style="margin-bottom: 10px">空调开</el-button>
              </el-col>
              <el-col :span="12">
                <el-button @click="operatorAir('close')" type="info" style="margin-bottom: 10px">空调关</el-button>
              </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="alterAirFormNew">匹配成功</el-button>
              <el-button @click="ariOperatorDialogVisibleNew = false">取 消</el-button>
            </div>
          </el-dialog>
          <!-- 设置空调SN -->
          <!-- 设备状态(新设备) -->
          <el-dialog title="设备状态" :visible.sync="deviceStatusDialogVisibleNew" width="50%" @close="code=''">
            <el-table :data="devices" height="250" border style="width: 100%">
              <el-table-column type="index" label="序号" width="100" align="center"/>
              <el-table-column label="类型" align="center">
                <template slot-scope="scope">
                  {{scope.row.lx === '0' ? '工控机' : scope.row.lx === '1' ? '大厅控制器' : scope.row.lx === '2' ? '淋浴控制器' : scope.row.lx === '3' ? '空调控制器' : scope.row.lx === '4' ? '工控机（二）' : scope.row.lx === '5' ? '第一门继电器' : '第二门继电器'}}
                </template>
              </el-table-column>
              <el-table-column label="状态" align="center">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.status ==='O'">在线</el-tag>
                  <el-tag type="danger" v-else>掉线</el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-dialog>
          <!-- 设备状态 -->
          <!-- 音乐库 -->
          <el-dialog title="音乐库" :visible.sync="musicDialogVisibleNew" width="50%" @close="musicDialogVisibleNew=false">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-refresh" size="mini" @click="handleSyncMusic()">同步音乐库</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-refresh" size="mini" @click="playMusic({musicTopic, id: storeId})">刷新</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-edit" size="mini" @click="settingTyMusic()" v-if="this.music.length > 0">设置日常音乐</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="success" size="mini" @click="handleOperaMusic('PLAY')" v-if="this.music.length > 0">播放</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin: 10px 0">
              <el-col :span="6">
                <el-button type="warning" size="mini" @click="handleOperaMusic('PAUSE')" v-if="this.music.length > 0">暂停</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" size="mini" @click="handleOperaMusic('NEXT')" v-if="this.music.length > 0">下一首</el-button>
              </el-col>
            </el-row>

            <el-table :data="music" height="450" border style="width: 100%">
              <el-table-column type="index" label="序号" width="100" align="center"/>
              <el-table-column label="音乐名称" prop="name" align="center"/>
              <el-table-column label="音乐时长" align="center">
                <template slot-scope="scope">
                  {{ formatMusicDuration(scope.row.duration) }}
                </template>
              </el-table-column>
              <el-table-column label="类型" align="center">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.is_ty =='1'">日常音乐</el-tag>
                  <el-tag type="primary" v-else>普通音乐</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="360" fixed="right" align="center">
                <!--作用域插槽-->
                <template slot-scope="scope">
                    <el-button type="success" size="mini" @click="handlePlayMusic(scope.row, 1)">点歌（插队）</el-button>
                    <el-button type="warning" size="mini" @click="handlePlayMusic(scope.row, 0)">点歌（顺序）</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-dialog>
          <!-- 音乐计划 -->
          <el-dialog title="广播任务" :visible.sync="musicPlanDialogVisibleNew" width="50%" @close="musicPlanDialogVisibleNew=false">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAddMusic()">添加</el-button>
              </el-col>
            </el-row>
            <el-table :data="musicPlan" height="450" border style="width: 100%">
              <el-table-column type="index" label="序号" width="100" align="center"/>
              <el-table-column label="计划名称" prop="planName" align="center"/>
              <el-table-column label="模版名称" prop="name" align="center"/>
              <el-table-column label="播放时间" prop="playTime" align="center"/>
              <el-table-column label="频率" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.repeatType == 1">每天</span>
                  <span v-else-if="scope.row.repeatType == 2">{{ scope.row.weekDays }}</span>
                </template>
              </el-table-column>
              <el-table-column label="开启" align="center" width="80">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.isOpen" :active-value="1" :inactive-value="0" @change="handleToggleMusicPlanOpen(scope.row)"></el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180" align="center">
                <!--作用域插槽-->
                <template slot-scope="scope">
                  <el-button type="success" icon="el-icon-edit" size="mini" @click="handleEditMusicPlan(scope.row)">编辑</el-button>
                  <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelMusicPlan(scope.$index, scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-dialog>
          <!-- 新增/编辑音乐计划 -->
          <el-dialog :title="planTitle" :visible.sync="operaMusicPlanDialogVisibleNew" width="50%" @close="operaMusicPlanDialogVisibleNew=false">
            <el-form ref="musicPlan" :model="musicPlanForm" :rules="musicPlanRules" label-width="120px">
              <el-form-item label="任务名称" prop="planName">
                <el-input v-model="musicPlanForm.planName" placeholder="请输入任务名称" clearable style="width:50%;"></el-input>
              </el-form-item>
              <el-form-item label="音频" prop="tempId">
                <el-select  v-model="musicPlanForm.tempId" clearable filterable placeholder="请选择音频" style="width:50%;">
                  <el-option :label="item.name" :value="item.id" :key="item.id" v-for="item in musicCk"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="播放时间" prop="defMinute">
                <div class="plan-time-tip">分钟 · 所有时段统一</div>
                <el-radio-group v-model="musicPlanForm.defMinute">
                  <el-radio :label="0">00分</el-radio>
                  <el-radio :label="15">15分</el-radio>
                  <el-radio :label="30">30分</el-radio>
                  <el-radio :label="45">45分</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="播放小时" prop="defHoursArr">
                <div class="plan-time-tip">可多选，灰色时间段已被其他广播任务占用，不可添加</div>
                <el-checkbox-group v-model="musicPlanForm.defHoursArr">
                  <el-checkbox v-for="h in 24" :key="h-1" :label="h-1" :disabled="occupiedHours.indexOf(pad2(h-1)) > -1" class="hour-checkbox">{{ pad2(h-1) }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="已选时间">
                <span v-if="playTimePreview.length">已选 {{ playTimePreview.length }} 个（{{ playTimePreview.join('、') }}）</span>
                <span v-else style="color:#999;">未选择</span>
              </el-form-item>
              <el-form-item label="重复频率" prop="repeatType">
                <el-radio-group v-model="musicPlanForm.repeatType">
                  <el-radio :label="1">每天</el-radio>
                  <el-radio :label="2">自定义</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="musicPlanForm.repeatType === 2" label="重复日期" prop="weekDaysArr">
                <el-checkbox-group v-model="musicPlanForm.weekDaysArr">
                  <el-checkbox v-for="d in weekOptions" :key="d.value" :label="d.value">{{ d.label }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="开启状态">
                <el-switch v-model="musicPlanForm.isOpen" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭"></el-switch>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="operaMusicPlanDialogVisibleNew = false">取 消</el-button>
              <el-button type="primary" @click="submitMusicPlan">确 定</el-button>
            </span>
          </el-dialog>
          <!-- 播放计划列表 -->
          <el-dialog title="播放计划" :visible.sync="playTaskDialogVisible" width="60%" @close="playTaskDialogVisible=false">
            <el-row :gutter="20" style="margin-bottom:10px;">
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAddPlayTask()">新增</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-refresh" size="mini" @click="handleSyncMusic()">同步音乐库</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-refresh" size="mini" @click="refreshMusicBoxInfo()" :loading="musicBoxLoading">刷新</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-bottom:10px;">
              <el-col :span="6">
                <el-button type="success" icon="el-icon-video-play" size="mini" @click="handleOperaMusic('PLAY')">播放</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="warning" icon="el-icon-video-pause" size="mini" @click="handleOperaMusic('PAUSE')">暂停</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-next" size="mini" @click="handleOperaMusic('NEXT')">下一首</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-bottom:10px; display:flex; align-items:center;">
              <el-col :span="12">
                <span style="font-size:14px; margin-right:10px;">音量</span>
                <el-slider v-model="musicBoxVolume" :min="0" :max="100" :disabled="musicBoxLoading" style="width:60%; display:inline-block; vertical-align:middle;" @change="handleSetVolume"></el-slider>
                <span style="margin-left:10px;">{{musicBoxVolume}}</span>
              </el-col>
              <el-col :span="6">
                <span style="font-size:14px; margin-right:10px;">音乐盒子</span>
                <el-switch v-model="musicBoxStatus" :active-value="1" :inactive-value="0" :disabled="musicBoxLoading" @change="handleSetPlayStatus"></el-switch>
              </el-col>
            </el-row>
            <el-table :data="playTaskList" height="450" border style="width: 100%">
              <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
              <el-table-column label="任务名称" prop="taskName" align="center"></el-table-column>
              <el-table-column label="开始时间" prop="startTime" align="center"></el-table-column>
              <el-table-column label="结束时间" prop="endTime" align="center"></el-table-column>
              <el-table-column label="播放标签" align="center">
                <template slot-scope="scope">
                  <el-tag v-for="(tag, index) in (scope.row.playTags || '').split(',')" :key="index" style="margin:2px 4px 2px 0;" size="mini" type="success">{{tag}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="播放类型" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="playTypeTagType(scope.row.playType)">{{playTypeName(scope.row.playType)}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                  <el-button type="success" icon="el-icon-edit" size="mini" @click="handleEditPlayTask(scope.row)">修改</el-button>
                  <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelPlayTask(scope.$index, scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-dialog>
          <!-- 新增/编辑播放任务 -->
          <el-dialog :title="playTaskTitle" :visible.sync="playTaskOperaDialogVisible" width="50%" @close="playTaskOperaDialogVisible=false">
            <el-form ref="playTaskForm" :model="playTaskForm" :rules="playTaskRules" label-width="120px">
              <el-form-item label="任务名称" prop="taskName">
                <el-input v-model="playTaskForm.taskName" placeholder="请输入任务名称" clearable></el-input>
              </el-form-item>
              <el-form-item label="开始时间" prop="startTime">
                <el-time-select v-model="playTaskForm.startTime" :picker-options="{ start: '00:00', step: '01:00', end: '23:59', maxTime: playTaskForm.endTime }" placeholder="请选择开始时间" style="width:100%;"></el-time-select>
              </el-form-item>
              <el-form-item label="结束时间" prop="endTime">
                <el-select v-model="playTaskForm.endTime" filterable placeholder="请选择结束时间" style="width:100%;">
                  <el-option v-for="t in endTimeOptions" :key="t" :label="t" :value="t"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="播放标签" prop="playTags">
                <el-select v-model="playTagsArr" multiple filterable placeholder="请选择播放标签" style="width:100%;">
                  <el-option v-for="item in musicTagOptions" :key="item.musicTag" :label="item.musicTag + '（' + item.musicCount + '首）'" :value="item.musicTag"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="播放类型" prop="playType">
                <el-radio-group v-model="playTaskForm.playType">
                  <el-radio :label="1">顺序</el-radio>
                  <el-radio :label="2">随机</el-radio>
                  <el-radio :label="3">列表循环</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="playTaskOperaDialogVisible = false">取 消</el-button>
              <el-button type="primary" :loading="btnLoading" @click="submitPlayTask">确 定</el-button>
            </span>
          </el-dialog>
          <!-- 设置日常音乐 -->
          <el-dialog title="设置日常音乐" :visible.sync="tyMusicDialogVisibleNew" width="50%" @close="tyMusicDialogVisibleNew=false">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-button type="primary" size="mini" @click="handleSaveTyMusic()">保存</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" size="mini" @click="handleAddTyMusic()">新增音乐</el-button>
              </el-col>
            </el-row>

            <el-table :data="tyMusic" height="450" border style="width: 100%">
              <el-table-column type="index" label="序号" width="100" align="center"/>
              <el-table-column label="音乐图片" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.img">
                    <el-popover placement="bottom"  width="310" trigger="click">
                      <div style="text-align: center;">
                        <img :src="imgURL_Front+'static/'+scope.row.img" mode="cover"  style="width:300px;height: 300px;border-radius: 5px;"/>
                      </div>
                      <img  slot="reference" :src="imgURL_Front+'static/'+scope.row.img" style="height: 30px;width: 30px;border-radius: 50%;">
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="音乐名称" prop="name" align="center"/>
              <el-table-column label="音乐时长" prop="duration" align="center"/>
              <el-table-column label="操作" width="360" fixed="right" align="center">
                <!--作用域插槽-->
                <template slot-scope="scope">
                    <el-button type="success" size="mini" @click="handleDelTyMusic(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-dialog>
          <!-- 选择音乐 -->
          <el-dialog title="选择音乐" :visible.sync="selectMusicDialogVisibleNew" width="50%" @close="selectMusicDialogVisibleNew=false">
            <el-form ref="selectMusic" :model="selectMusicForm" :rules="selectMusicRules" label-width="120px">
              <el-form-item label="音乐" prop="codes">
                <el-select  v-model="selectMusicForm.codes" filterable multiple placeholder="请选择音乐" style="margin-right:10px">
                  <el-option :label="item.name" :value="item.code" :key="item.code" v-for="item in kxMusic"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="selectMusicDialogVisibleNew = false">取 消</el-button>
              <el-button type="primary" @click="submitSelectMusic">确 定</el-button>
            </span>
          </el-dialog>

          <!-- 设置开卡时间弹窗 -->
          <el-dialog title="设置开卡时间" :visible.sync="openCardDialogVisible" width="30%">
            <el-form :model="openCardForm" label-width="120px">
              <el-form-item label="开卡时间(天)">
                <el-input-number v-model="openCardForm.openCardDays" :min="0" :max="365" label="开卡时间(天)"></el-input-number>
                <div style="color: #909399; font-size: 12px; margin-top: 5px;">店铺默认开卡时间</div>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="openCardDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submitOpenCardDays" :loading="btnLoading">确 定</el-button>
            </span>
          </el-dialog>

          <!-- 延长会员卡天数对话框 -->
          <el-dialog
            title="批量延长会员卡有效期"
            :visible.sync="extendCardsDialogVisible"
            width="500px"
            :close-on-click-modal="false">
            <div style="padding: 0 20px;">
              <!-- 店铺信息卡片 -->
              <el-card shadow="never" style="margin-bottom: 20px; background-color: #f5f7fa;">
                <div style="display: flex; align-items: center;">
                  <i class="el-icon-s-shop" style="font-size: 24px; color: #409EFF; margin-right: 12px;"></i>
                  <div>
                    <div style="font-size: 14px; color: #909399; margin-bottom: 4px;">当前店铺</div>
                    <div style="font-size: 16px; font-weight: 600; color: #303133;">{{ extendCardsForm.storeName }}</div>
                  </div>
                </div>
              </el-card>

              <!-- 操作说明 -->
              <el-alert
                title="操作说明"
                type="warning"
                :closable="false"
                show-icon
                style="margin-bottom: 20px;">
                <div slot="default">
                  <p style="margin: 0 0 8px 0;">此操作将延长该店铺所有符合条件的会员卡有效期</p>
                  <ul style="margin: 0; padding-left: 20px; font-size: 12px; color: #606266;">
                    <li>仅延长未过期的普通会员卡</li>
                    <li>不包括：体验卡、店主卡、已过期的卡</li>
                    <li>同时更新结束时间和有效天数字段</li>
                  </ul>
                </div>
              </el-alert>

              <!-- 表单 -->
              <el-form :model="extendCardsForm" :rules="extendCardsFormRules" ref="extendCardsFormRef" label-width="100px">
                <el-form-item label="延长天数" prop="days">
                  <el-input-number
                    v-model="extendCardsForm.days"
                    :min="1"
                    :max="100"
                    :precision="0"
                    controls-position="right"
                    placeholder="请输入延长天数"
                    style="width: 100%;">
                  </el-input-number>
                  <div style="color: #909399; font-size: 12px; margin-top: 8px; line-height: 1.5;">
                    <i class="el-icon-info" style="margin-right: 4px;"></i>
                    可延长 1-100 天，将在原有效期基础上增加
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="extendCardsDialogVisible = false" size="medium">取 消</el-button>
              <el-button type="primary" @click="submitExtendCards" :loading="extendCardsLoading" size="medium">
                <i class="el-icon-check" v-if="!extendCardsLoading"></i>
                {{ extendCardsLoading ? '处理中...' : '确认延长' }}
              </el-button>
            </span>
          </el-dialog>

          <!-- 店主管理统一对话框 -->
          <el-dialog title="门店人员管理" :visible.sync="storeOwnerManagerVisible" width="75%" top="8vh" @close="closeStoreOwnerManager" class="store-owner-dialog">
            <div class="manager-container">
              <!-- 左侧：查询和店主信息 -->
              <div class="left-panel">
                <el-card shadow="hover" class="search-card">
                  <div slot="header" class="card-header">
                    <i class="el-icon-search"></i>
                    <span>查询门店人员</span>
                  </div>
                  <div class="search-form-section">
                    <el-form :model="managerForm" label-width="80px">
                      <el-form-item label="手机号">
                        <el-input
                          v-model="managerForm.phone"
                          placeholder="请输入人员手机号"
                          clearable
                          size="medium">
                          <el-button slot="append" @click="searchOwnerStores" :loading="searchLoading" type="primary">
                            <i class="el-icon-search"></i>
                          </el-button>
                        </el-input>
                      </el-form-item>
                    </el-form>
                  </div>

                  <!-- 实名认证信息卡片 -->
                  <div v-if="ownerStoresList.length > 0" class="auth-info-section">
                    <div class="auth-info-card">
                      <div class="auth-info-header">
                        <div class="auth-header-left">
                          <i class="el-icon-lock"></i>
                          <span>实名信息</span>
                          <el-tag v-if="ownerAuthInfo.authStatus == 2" type="success" size="small">已认证</el-tag>
                          <el-tag v-else-if="ownerAuthInfo.authStatus == 1" type="warning" size="small">认证中</el-tag>
                          <el-tag v-else-if="ownerAuthInfo.authStatus == 3" type="danger" size="small">认证失败</el-tag>
                          <el-tag v-else type="info" size="small">未认证</el-tag>
                        </div>
                        <el-button
                          v-if="ownerAuthInfo.authStatus == 2"
                          type="text"
                          size="small"
                          @click="clearOwnerAuth()"
                          class="clear-auth-btn">
                          <i class="el-icon-delete"></i> 清除实名
                        </el-button>
                      </div>
                      <div class="auth-info-body">
                        <div class="auth-info-row">
                          <div class="auth-info-item">
                            <span class="auth-label">姓名</span>
                            <span class="auth-value">{{ ownerAuthInfo.realName ? ownerAuthInfo.realName : '--' }}</span>
                          </div>
                          <div class="auth-info-item">
                            <span class="auth-label">身份证号</span>
                            <span class="auth-value">{{ ownerAuthInfo.idcard ? ownerAuthInfo.idcard : '--' }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 已关联门店列表 -->
                  <div v-if="ownerStoresList.length > 0" class="associated-stores">
                    <div class="section-title">
                      <i class="el-icon-shop"></i>
                      已关联门店 ({{ownerStoresList.length}})
                    </div>
                    <div class="associated-table-container">
                      <el-input placeholder="请输入内容" v-model="searchStore" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search" @click="handleSearchOwnerStore"></el-button>
                      </el-input>
                      <el-table :data="filterOwnerStoresList" size="small" border class="associated-table">
                        <el-table-column label="门店名称" prop="storename" show-overflow-tooltip></el-table-column>
                        <el-table-column label="门店地址" prop="address" show-overflow-tooltip></el-table-column>
                        <el-table-column label="所属角色" prop="roleName" show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" width="70" align="center">
                          <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="removeOwnerAssociation(scope.row)" class="remove-btn">
                              <i class="el-icon-delete"></i> 移除
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>

                  <div v-else-if="managerForm.phone && !searchLoading" class="no-data">
                    <i class="el-icon-info"></i>
                    <span>该手机号暂无关联门店</span>
                  </div>
                </el-card>
              </div>

              <!-- 右侧：门店选择 -->
              <div class="right-panel">
                <el-card shadow="hover" class="stores-card">
                  <div slot="header" class="card-header">
                    <div class="header-left">
                      <i class="el-icon-office-building"></i>
                      <span>门店选择</span>
                    </div>
                    <div class="header-right">
                      <el-button
                        size="small"
                        type="warning"
                        @click="loadAllStores"
                        :loading="storesLoading"
                        class="load-stores-btn">
                        <i class="el-icon-refresh"></i> 加载门店
                      </el-button>
                    </div>
                  </div>

                  <div v-if="allStoresList.length > 0">
                    <el-row :gutter="10">
                      <el-col :span="18">
                        <!-- 状态筛选按钮 -->
                        <div class="store-status-filter" style="margin-bottom: 15px;">
                          <el-button-group>
                            <el-button
                                :type="storeStatusFilter === '' ? 'primary' : 'default'"
                                size="small"
                                @click="setStoreStatusFilter('')">
                              <i class="el-icon-s-grid"></i> 全部
                            </el-button>
                            <el-button
                                :type="storeStatusFilter === '1' ? 'success' : 'default'"
                                size="small"
                                @click="setStoreStatusFilter('1')">
                              <i class="el-icon-check"></i> 营业
                            </el-button>
                            <el-button
                                :type="storeStatusFilter === '2' ? 'info' : 'default'"
                                size="small"
                                @click="setStoreStatusFilter('2')">
                              <i class="el-icon-close"></i> 关闭
                            </el-button>
                            <el-button
                                :type="storeStatusFilter === '3' ? 'warning' : 'default'"
                                size="small"
                                @click="setStoreStatusFilter('3')">
                              <i class="el-icon-setting"></i> 装修
                            </el-button>
                          </el-button-group>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <el-select v-model="role" clearable placeholder="请选择角色">
                          <el-option
                              v-for="item in roles"
                              :key="item.roleKey"
                              :label="item.roleName"
                              :value="item.roleKey">
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-row>

                    <!-- 搜索框 -->
                    <el-input
                      v-model="storeSearchText"
                      placeholder="搜索门店名称..."
                      prefix-icon="el-icon-search"
                      size="small"
                      style="margin-bottom: 15px;"
                      clearable>
                    </el-input>

                    <!-- 全选控制 -->
                    <div class="select-controls">
                      <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="checkAll"
                        @change="handleCheckAllChange">
                        全选
                      </el-checkbox>
                      <span class="selected-count">已选择 {{checkedStores.length}} / {{filteredStores.length}} 个门店</span>
                    </div>

                    <!-- 门店列表 -->
                    <div class="stores-list">
                      <el-checkbox-group v-model="checkedStores" @change="handleCheckedStoresChange">
                        <el-row :gutter="12">
                          <el-col :span="12" v-for="store in filteredStores" :key="store.id">
                            <div class="store-card" :class="{ 'selected': checkedStores.includes(store.id) }">
                              <el-checkbox :label="store.id" class="store-checkbox">
                                <div class="store-content">
                                  <div class="store-header">
                                    <el-tooltip :content="store.storename" placement="top" :disabled="store.storename.length <= 20">
                                      <span class="store-name">{{truncateText(store.storename, 20)}}</span>
                                    </el-tooltip>
                                    <el-tag size="mini" type="info" class="store-id">ID: {{store.id}}</el-tag>
                                  </div>
                                  <el-tooltip :content="store.address || '暂无地址信息'" placement="top" :disabled="(store.address || '暂无地址信息').length <= 20">
                                    <div class="store-address">{{truncateText(store.address || '暂无地址信息', 20)}}</div>
                                  </el-tooltip>
                                  <div v-if="store.telephone" class="store-phone">
                                    <i class="el-icon-phone"></i> {{store.telephone}}
                                  </div>
                                </div>
                              </el-checkbox>
                            </div>
                          </el-col>
                        </el-row>
                      </el-checkbox-group>
                    </div>
                  </div>

                  <div v-else class="no-data">
                    <i class="el-icon-box"></i>
                    <span>请先加载门店列表</span>
                  </div>
                </el-card>
              </div>
            </div>

            <!-- 底部操作按钮 -->
            <div slot="footer" class="dialog-footer">
              <div class="footer-info" v-if="checkedStores.length > 0">
                <div class="summary-card">
                  <i class="el-icon-info"></i>
                  <span>将为手机号 <strong>{{managerForm.phone}}</strong> 设置 <strong>{{checkedStores.length}}</strong> 个门店的{{ role ? roles.filter(item => item.roleKey === this.role)[0].roleName : ''}}权限</span>
                </div>
              </div>
              <div class="footer-buttons">
                <el-button @click="closeStoreOwnerManager" size="medium">
                  <i class="el-icon-close"></i> 取消
                </el-button>
                <el-button
                  type="primary"
                  @click="submitStoreOwnerChanges"
                  :loading="submitLoading"
                  :disabled="!managerForm.phone || checkedStores.length === 0"
                  size="medium">
                  <i class="el-icon-check"></i> 确认设置
                </el-button>
              </div>
            </div>
          </el-dialog>
        </el-card>

      <!-- 美团授权对话框 -->
      <el-dialog :title="title" :visible.sync="openShowMt" @close="handleQuery" fullscreen append-to-body>
        <iframe ref="mtAuth" :src="mtAuthUrl" style="width: 100%;height: 100vh"></iframe>
      </el-dialog>

      <!-- 邀请分享设置弹窗 -->
      <el-dialog title="邀请分享设置" :visible.sync="shareSettingDialogVisible" width="380px" :close-on-click-modal="false">
        <el-form :model="shareSettingForm" label-width="110px">
          <el-form-item label="门店">
            <span style="font-weight:600;">{{ shareSettingForm.storeName }}</span>
          </el-form-item>
          <el-form-item label="开启邀请分享">
            <el-switch v-model="shareSettingForm.shareEnabled" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭"></el-switch>
          </el-form-item>
          <el-form-item label="邀请奖励天数">
            <el-input-number v-model="shareSettingForm.shareRewardDays" :min="0" :max="365" size="small"></el-input-number>
            <div style="color:#909399;font-size:12px;margin-top:4px;">被邀请人购卡后邀请人获得天数</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="shareSettingDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitShareSetting" :loading="btnLoading">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>
<script>
import axios from "axios";
import {saveAs} from "file-saver";
import {Loading} from "element-ui";

export default {
    data() {
        return {
          ismeituan59: false,
          tableLoading: false,
          musicTableLoading: false,
          syncLoading: false,
          musicTopic:'',
          storeId: null,
          imgURL_Front:this.GLOBAL.imgURL_Front,
          storeMainers: [],
          allPeople: 0,
          openShowMt: false,
          mtAuthUrl: null,
          title: null,
          planTitle: '',
          music: [],
          musicPlan: [],
          plArr: [
            {
              id: 1,
              name: '1小时/次'
            },
            {
              id: 2,
              name: '2小时/次'
            },
            {
              id: 3,
              name: '3小时/次'
            },
            {
              id: 4,
              name: '4小时/次'
            },
            {
              id: 5,
              name: '5小时/次'
            },
            {
              id: 6,
              name: '6小时/次'
            },
            {
              id: 12,
              name: '12小时/次'
            },
            {
              id: 24,
              name: '24小时/次'
            }
          ],
          musicCk: [],
          tyMusic: [],
          kxMusic: [],
          devices: [],
          musicDialogVisibleNew: false,
          musicPlanDialogVisibleNew: false,
          operaMusicPlanDialogVisibleNew: false,
          tyMusicDialogVisibleNew: false,
          selectMusicDialogVisibleNew: false,
          deviceStatusDialogVisibleNew: false,
          ariOperatorDialogVisibleNew: false,
          btnLoading: false,
          // 邀请分享设置相关
          shareSettingDialogVisible: false,
          shareSettingForm: {
            storeId: null,
            storeName: '',
            shareEnabled: 0,
            shareRewardDays: 1
          },
          // 开卡时间相关
          openCardDialogVisible: false,
          openCardForm: {
            storeId: null,
            openCardDays: 0
          },
          selectMusicForm: {
            codes: []
          },
          selectMusicRules: {
            codes: [
              { required: true, message: '请选择音乐', trigger: 'blur' },
            ]
          },
          musicPlanForm: {},
          occupiedHours: [],
          fetchSeq: 0,
          weekOptions: [
            { value: 1, label: '周一' },
            { value: 2, label: '周二' },
            { value: 3, label: '周三' },
            { value: 4, label: '周四' },
            { value: 5, label: '周五' },
            { value: 6, label: '周六' },
            { value: 7, label: '周日' }
          ],
          musicPlanRules: {
            planName: [
              { required: true, message: '请输入任务名称', trigger: 'blur' },
            ],
            tempId: [
              { required: true, message: '请选择音频', trigger: 'blur' },
            ],
            defMinute: [
              { required: true, message: '请选择播放分钟', trigger: 'change' },
            ],
            defHoursArr: [
              { required: true, type: 'array', min: 1, message: '请选择播放小时', trigger: 'change' },
            ],
            repeatType: [
              { required: true, message: '请选择重复频率', trigger: 'change' },
            ],
            weekDaysArr: [
              { validator: (rule, value, callback) => {
                  if (this.musicPlanForm.repeatType === 2 && (!value || !value.length)) {
                    callback(new Error('请选择重复日期'))
                  } else {
                    callback()
                  }
                }, trigger: 'change' }
            ]
          },
          // 播放计划相关
          playTaskDialogVisible: false,
          playTaskOperaDialogVisible: false,
          playTaskTitle: '新增播放任务',
          playTaskList: [],
          musicTagOptions: [],
          musicBoxVolume: 0,
          musicBoxStatus: 0,
          musicBoxLoading: false,
          playTagsArr: [],
          playTaskForm: {
            id: null,
            storeId: null,
            taskName: '',
            startTime: null,
            endTime: null,
            playTags: '',
            playType: 1
          },
          playTaskRules: {
            taskName: [
              { required: true, message: '请输入任务名称', trigger: 'blur' }
            ],
            startTime: [
              { required: true, message: '请选择开始时间', trigger: 'change' }
            ],
            endTime: [
              { required: true, message: '请选择结束时间', trigger: 'change' }
            ],
            playTags: [
              { required: true, message: '请选择播放标签', trigger: 'change' }
            ],
            playType: [
              { required: true, message: '请选择播放类型', trigger: 'change' }
            ]
          },
          // 延长会员卡天数相关
          extendCardsDialogVisible: false,
          extendCardsLoading: false,
          extendCardsForm: {
            storeId: null,
            storeName: '',
            days: 30
          },
          extendCardsFormRules: {
            days: [
              { required: true, message: '请输入延长天数', trigger: 'blur' },
              { type: 'number', min: 1, max: 100, message: '延长天数必须在1-100天之间', trigger: ['blur', 'change'] },
              {
                validator: (rule, value, callback) => {
                  if (value === null || value === undefined || value === '') {
                    callback(new Error('请输入延长天数'))
                  } else if (!Number.isInteger(value)) {
                    callback(new Error('延长天数必须是整数'))
                  } else if (value < 1 || value > 100) {
                    callback(new Error('延长天数必须在1-100天之间'))
                  } else {
                    callback()
                  }
                },
                trigger: ['blur', 'change']
              }
            ]
          },
          // 店主管理相关
          storeOwnerManagerVisible: false,
          managerForm: {
            phone: ''
          },
          ownerStoresList: [],
          filterOwnerStoresList: [],
          searchStore: null,
          allStoresList: [],
          checkedStores: [],
          checkAll: false,
          isIndeterminate: false,
          searchLoading: false,
          storesLoading: false,
          submitLoading: false,
          storeSearchText: '',
          storeStatusFilter: '', // 门店状态筛选：'' 全部, '1' 营业, '2' 关闭, '3' 装修
          allStoreOwners: {}, // 存储所有门店的店主信息
          imgURL:this.GLOBAL.imgURL,
          admin_token: '',
          perid_token: '',
          queryInfo: {
              query: '',
              query1:'',
              query2:'',
            skType: null,
            newDevice: null,
            lockStatus: '',
              pagenum: 1,
              pagesize: 20
          },
          total:0,
          list: [],
          bath_username:'',
          bathlist:[],
          addDialogVisible:false,
          editDialogVisible:false,
          setDialogVisible:false,
          setDialogVisibleTx:false,
          settingDialogVisible:false,
          bathDialogVisible:false,
          ariDialogVisible:false,
          //编辑表单数据
          editForm:{},
          openPp: false,
          openSdPp: false,
          isExec: false,
          wgAddFlag: false,
          airDevAddFlag: false,
          wgForm: {
            gateway: null,
            type: '0',
            storeid: null
          },
          wgRules:{
            gateway: [
              { required: true, message: "网关主题不能为空", trigger: "blur" },
              { max: 100, message: '网关主题长度最多 100个字', trigger: 'blur' }
            ],
          },
          airDevForm: {
            gateway: null,
            storeid: null,
            far: null
          },
          airDevRules:{
            far: [
              { required: true, message: "设备地址不能为空", trigger: "blur" },
              { max: 100, message: '设备地址长度最多 100个字', trigger: 'blur' }
            ],
          },
          kfidStr: null,
          // 品牌码集合
          kfidArr: [],
          brandArr: [],
          kfidIndex: 0,
          // 品牌码
          kfid: null,
          ppForm: {
            ppMethod: '1',
            brand: null,
            far: null,
            gateway: null,
            id: null
          },
          ppRules:{
            brand: [
              { required: true, message: "品牌不能为空", trigger: "blur" },
            ],
          },
            //添加表单验证规则
            editFormRules:{
                storename:[
                    { required: true, message: '请输入门店名称', trigger: 'blur' }
                ],
                alarm:[
                    { required: true, message: '请输入欠设备款', trigger: 'blur' }
                ],
                points: [
                    { required: true, message: '请输入总部扣点', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            const numberValue = Number(value);
                            if (!value) {
                                callback(new Error('请输入总部扣点'));
                            } else if (isNaN(numberValue)) {
                                callback(new Error('必须是数字'));
                            } else if (numberValue < 0) {
                                callback(new Error('不能是负数'));
                            } else if (value.includes('.') && !value.startsWith('0.')) {
                                callback(new Error('格式不正确'));
                            } else {
                                callback(); // 验证通过
                            }
                        },
                        trigger: 'blur'
                    },
                ],
                agencyPoints: [
                    { required: true, message: '请输入代账发卡扣点', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            // 必填规则已拦截空值；这里校验：数字 / 不能为0 / 小数点最多2位 / >=0.01 / <1
                            if (value === null || value === undefined || String(value).trim() === '') {
                                callback();
                                return;
                            }
                            const str = String(value).trim();
                            const numberValue = Number(str);
                            if (isNaN(numberValue)) {
                                callback(new Error('必须是数字'));
                            } else if (numberValue <= 0) {
                                callback(new Error('不能为 0，必须大于 0'));
                            } else if (!/^\d+(\.\d{1,2})?$/.test(str)) {
                                callback(new Error('小数点后最多保留 2 位'));
                            } else if (numberValue < 0.01) {
                                callback(new Error('不能小于 0.01'));
                            } else if (numberValue >= 1) {
                                callback(new Error('需小于 1（如 0.05）'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    },
                ],
                submchid: [
                    { required: true, message: '请输入子商户号', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            const numberValue = Number(value);
                            if (!value) {
                                callback(new Error('请输入子商户号'));
                            } else if (isNaN(numberValue)) {
                                callback(new Error('子商户号必须是数字'));
                            } else if (value.length < 8 || value.length > 10) {
                                callback(new Error('子商户号必须是8到10位'));
                            } else {
                                callback(); // 验证通过
                            }
                        },
                        trigger: 'blur'
                    },
                ],


            },
            storeid:"",
            dynamicValidateForm: {
                owners: [
                  {
                      username: '',
                      percentage: '',
                      authStatus: undefined,
                      key: Date.now(),
                    roleKeys: [],
                    roleList: [],
                    menuList: [],
                    istx: null,
                    isaudit: null,
                  }
                ]
            },
          dynamicValidateTxForm: {
            storename: null,
            storeId: null,
            id: null,
            users: []
          },
            // airForm: {
            //     gateway:'',
            //     fars: [
            //         {
            //             sn: '',
            //             percentage: '',
            //             key: Date.now()
            //         }
            //     ]
            // },
            airForm: [],
          // 空调设备
          airDevice: [],
          wgType: '0',
          gatewar: null,
            airFormNew: [],
            code:'',
          ariDialogVisibleNew: false,
          ports: [
            {
              value: 'D1',
              label: '一路'
            },
            {
              value: 'D2',
              label: '二路'
            },
            {
              value: 'D3',
              label: '三路'
            },
            {
              value: 'D4',
              label: '四路'
            }
          ],
          airTypes: [
            {
              value: '0',
              label: '红外'
            },
            {
              value: '1',
              label: '小超人'
            },
            {
              value: '2',
              label: '集控网关'
            }
          ],
          airManagerIndex: null,
          airIndex: null,
          topic: null,
          username: null,
          roleList: [],
          deptRoleXz: {
            managerNum: null,
            ownerNum: null,
            clearNum: null,
            associateNum: null
          },
          role: null,
          roles: []
        }
    },
    created() {
      this.getAudit()
      this.getInitData()
         this.getList()
         this.admin_token = window.sessionStorage.getItem('admin_token')
    },
    mounted(){
      this.admin_token = window.sessionStorage.getItem('admin_token')
      this.perid_token = window.sessionStorage.getItem('perid_token')
      this.username = window.sessionStorage.getItem('username')
    },
    watch: {
      playTagsArr(val) {
        this.playTaskForm.playTags = val.join(',')
        if (this.playTaskOperaDialogVisible) {
          this.$nextTick(() => {
            this.$refs.playTaskForm && this.$refs.playTaskForm.validateField('playTags')
          })
        }
      },
      // 分钟变化时查询已被其他播放计划占用的小时
      'musicPlanForm.defMinute'() {
        this.fetchUsedDefHours()
      }
    },
    methods:{
      async getInitData() {
        const { data:res } = await this.$http.get('xcxRole/listXlk')
        if(res.code == 200) {
          this.roleList = res.data
          if (this.roleList.length > 0) {
            this.roles = this.roleList.filter(item => item.isDelete == '1')
            this.roleList = this.roleList.filter(item => item.isDelete == '0')
          }
        }
      },
      async getAudit() {
        const { data:res } = await this.$http.get('api/getMtTdAudit')
        if(res.data.status == 0) {
          this.ismeituan59 = true
        } else {
          this.ismeituan59 = false
        }
      },
      parseDate(date) {
        let dat = new Date(date)
        return (dat.getHours() > 10 ? dat.getHours() : '0' + dat.getHours()) + ':' + (dat.getMinutes() > 10 ? dat.getMinutes() : '0' + dat.getMinutes())
      },
      // 同步到知识库
      async syncToKnowledgeBase() {
        this.$confirm('确认将所有门店信息同步到知识库系统？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.syncLoading = true;
          try {
            const { data: res } = await this.$http.post('/api/store/sync-to-knowledge-base');
            if (res.code === 200) {
              const result = res.data;
              this.$message({
                type: 'success',
                message: `同步成功！总计: ${result.total}个，成功: ${result.successCount}个，失败: ${result.failCount}个`,
                duration: 5000
              });
              if (result.errors) {
                this.$message({
                  type: 'warning',
                  message: '部分门店同步失败: ' + result.errors,
                  duration: 8000
                });
              }
            } else {
              this.$message.error(res.msg || '同步失败');
            }
          } catch (error) {
            console.error('同步失败:', error);
            this.$message.error(error.response?.data?.msg || '同步失败，请稍后重试');
          } finally {
            this.syncLoading = false;
          }
        }).catch(() => {
          this.$message.info('已取消同步');
        });
      },
      // 文本截断方法
      truncateText(text, maxLength) {
        if (!text) return '';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
      },
      filterPort(val, data){
        let arr = data.map(item=> item.port)
        return this.ports.filter(relay => arr.indexOf(relay.value) === -1 || relay.value === val)
      },
        isAdmin() {
            const username = window.sessionStorage.getItem('admin_token');
            return username === 'admin';
        },
        hasDoorPermission() {
            // 获取权限列表
            const perid_token = window.sessionStorage.getItem('perid_token');
            if (!perid_token) return false;

            try {
                // 检查原始字符串是否包含进门开关权限
                if (perid_token.includes('进门开关')) {
                    return true;
                }

                // 尝试将字符串类型的 perid_token 转为数组
                let peridArray = perid_token;
                if (perid_token.startsWith("[") && !perid_token.startsWith("['")) {
                    // 如果是JSON格式的数组字符串
                    const peridList = JSON.parse(perid_token);
                    return peridList.includes('进门开关');
                } else {
                    // 如果是Python格式的列表字符串 "['item1', 'item2']"
                    peridArray = perid_token.replace(/'/g, '"'); // 替换单引号为双引号
                    const peridList = JSON.parse(peridArray); // 转换为数组
                    return peridList.includes('进门开关');
                }
            } catch (error) {
                // 如果解析失败，直接检查字符串是否包含权限名
                return perid_token.includes('进门开关');
            }
        },
        async openDoor(sn,topic, faceLocal) {
            if (!sn) {
                return this.$message.error('该门店没有设置进门SN');
            }
            // AB门开关
            try {
              await this.$http.get(`${this.deviceURL}mdoor?sn=${sn}&topic=${topic}&faceLocal=${faceLocal}`, { timeout: 5000 });
              this.$message.success('已发送进门开关命令');
            } catch (error) {
                console.error('进门开关请求失败:', error);
                this.$message.error('进门开关请求失败');
            }
        },
        async getList() {
          this.tableLoading = true
          try {
            const { data:res } = await this.$http.get('storelist/',{ params: this.queryInfo, timeout: 15000 })
            this.tableLoading = false
            if(res.status != 1 || !res.data || !res.data.list) {
              this.list = []
              this.total = 0
              return
            }
            this.total = res.data.totalCount;
            this.allPeople = res.data.allPeople;
            this.list = res.data.list.map(v => v.fields)
            for (let index = 0; index < res.data.list.length; index++) {
              this.list[index].id = res.data.list[index].pk;
            }
          } catch (error) {
            this.tableLoading = false
            this.list = []
            this.total = 0
            console.error('获取门店列表失败:', error)
          }
        },
      handleQuery() {
        this.queryInfo.pagenum = 1
        this.getList()
      },
        handleSizeChange(newSize){
          // console.log(newSize)
           this.queryInfo.pagesize = newSize
           this.getList()
        },
        handleCurrentChange(newPage){
            // console.log(newPage)
            this.queryInfo.pagenum = newPage
            this.getList()
        },
        AddStore(){
                // 使用完全刷新的方式导航到添加门店页面
                window.location.href = '#/storeadd'
        },
        ExportStore(){
          let downloadLoadingInstance = Loading.service({
            text: "正在下载数据，请稍候",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          axios
              .get("/storelist/export", {
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                responseType: "blob",
                params: this.queryInfo,
              })
              .then(async (data) => {
                const isBlob = data.data.type !== "application/json";
                if (isBlob) {
                  const blob = new Blob([data.data]);
                  saveAs(blob, `门店数据_${new Date().getTime()}.xlsx`);
                } else {
                  this.$message.error("导出门店数据失败");
                }
                downloadLoadingInstance.close();
              })
              .catch((r) => {
                console.error(r);
                this.$message.error("下载文件出现错误，请联系管理员！");
                downloadLoadingInstance.close();
              });
        },
        EditStore(id){
                // 使用完全刷新的方式导航到编辑门店页面
                window.location.href = `#/storeedit/${id}`
        },
        MarkStore(id){
                // 使用完全刷新的方式导航到标注门店页面
                window.location.href = `#/storemark/${id}`
        },
        async DelStore(id){
            const confirmResult = await this.$confirm('是否要删除此门店吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).catch(err => err)

                if (confirmResult !== 'confirm'){
                    return this.$message.info('已取消删除！')
                }
                const { data: res } = await this.$http.get('/storedel/'+ id)

                if (res.status === 0) {
                    this.$message({message: '删除成功！',type: 'success'})
                }
                this.getList()
        },
        async SetBoss(row){
          this.deptRoleXz.managerNum = row.managerNum
          this.deptRoleXz.ownerNum = row.ownerNum
          this.deptRoleXz.clearNum = row.clearNum
          this.deptRoleXz.associateNum = row.associateNum
          console.log('门店限制数量：')
          console.log(this.deptRoleXz)
            // console.log(storeid);
            const { data: res } = await this.$http.get('storeuserinfo/boss', { params: { id: row.id } })
            if(res.code == 0){
                this.dynamicValidateForm.owners = res.data.length ? res.data.map(item => ({
                    username: item.username,
                    authStatus: item.authStatus,
                    realName: item.realName || '',
                    idcard: item.idcard || '',
                    roleKeys: item.roleKeys || [],
                    roleList: [],
                    menuList: [],
                    istx: item.istx,
                    isaudit: item.isaudit,
                    key: Date.now() + Math.random()
                })) : [{ username: '', authStatus: undefined, realName: '', idcard: '', key: Date.now(), roleKeys: [], roleList: [] }];
              this.filterRole('init')
            }
            this.setDialogVisible = true
            this.storeid = row.id
        },
        async SetTxUser(row){
          const { data: res } = await this.$http.get('storeuserinfo/boss', { params: { id: row.id } })
          if(res.code == 0){
            let arr = res.data.length ? res.data : [{ username: '', disable: false }];
            arr.forEach(item => {
              item.disable = false
            })
            this.storeMainers = arr
          }

          const { data: res2 } = await this.$http.get('getTxUser/'+row.id)
          this.dynamicValidateTxForm.users = []
          if(res2.status == 0 && res2.data.length > 0){
            this.dynamicValidateTxForm.users = res2.data

            this.dynamicValidateTxForm.users.forEach(item => {
              let obj = this.storeMainers.filter(i => i.username == item.username)
              if (!obj || obj.length == 0){
                this.storeMainers.push({ username: item.username, disable: true })
              }
            })
          }
          this.dynamicValidateTxForm.id = row.bfId;
          this.dynamicValidateTxForm.storename = row.storename;
          this.dynamicValidateTxForm.storeId = row.id;
          this.setDialogVisibleTx = true
        },
        setDialogTxClosed(){
            this.setDialogVisibleTx = false
        },
        setDialogClosed(){
            this.setDialogVisible = false
        },
        async Setting(id){
                const { data: res } = await this.$http.get('storeinfo/' + id )
                this.editForm = res
                if (!res.points) {
                  res.points = '0.08'
                }
                // 代账发卡扣点：保证字段存在以触发 Vue2 响应式；留空表示回退用通用扣点
                if (res.agencyPoints === undefined || res.agencyPoints === null) {
                  res.agencyPoints = ''
                }
                if (!res.alarm) {
                  res.alarm = '0'
                }
                if (res.isfz == null) {
                  res.isfz = '0'
                }
                this.editForm.admin_token = this.admin_token
                this.settingDialogVisible = true
        },
        settingDialogClosed(){
            this.settingDialogVisible = false
        },
        submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                  let successFlag = []
                  const usernames = this.dynamicValidateForm.owners.map(item => {
                    if (item.roleKeys.length == 0) {
                      successFlag.push(item.username)
                    }
                    return {username: item.username, roleKeys: item.roleKeys || [], istx: item.istx, isaudit: item.isaudit}
                  });
                  if (successFlag.length > 0) {
                    this.$message({message: successFlag.join('、') + '，请设置角色后再进行提交',type: 'error'})
                    return
                  }
                  const hasDuplicateUsername = (arr) => {
                    const seen = new Set();
                    return arr.some(item => {
                      if (seen.has(item.username)) return item.username;
                      seen.add(item.username);
                      return null;
                    });
                  };
                  let duplicateUsername = hasDuplicateUsername(usernames)
                    if(duplicateUsername){
                        this.$message({message: duplicateUsername + '重复，请勿重复设置用户',type: 'error'})
                        return
                    }
                    const { data: res } = await this.$http.post('storeuserinfo/boss',{storeid:this.storeid,formDataRole:usernames,admin_token:this.admin_token})
                    if(res.code == 0){
                        this.$message({message: '设置成功！',type: 'success'})
                        this.setDialogVisible = false
                    } else {
                      this.$message({message: res.msg,type: 'error'})
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        submitTxForm() {
            this.$refs.dynamicValidateTxForm.validate(async (valid) => {
                if (valid) {
                    const { data: res } = await this.$http.post('setTxForm/',this.dynamicValidateTxForm)
                    if(res.status == 0){
                      this.$message({message: '设置成功！',type: 'success'})
                      this.setDialogVisibleTx = false
                      this.getList()
                    } else {
                      this.$message({message: res.message,type: 'danger'})
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        removeOwner(item) {
            const index = this.dynamicValidateForm.owners.indexOf(item);
            if (this.dynamicValidateForm.owners.length > 1 && index !== -1) {
                this.dynamicValidateForm.owners.splice(index, 1);
            }
            this.filterRole()
        },
        async checkOwnerAuth(index) {
            const owner = this.dynamicValidateForm.owners[index]
            if (!owner || !owner.username) {
                return
            }
            const regMobile = /^1[3-9][0-9]{9}$/
            if (!regMobile.test(owner.username)) {
                return
            }
            try {
                const { data: res } = await this.$http.get('/api/v2/store-owner/search-by-phone', {
                    params: { username: owner.username }
                })
                if (res.status === 0 && res.data && res.data.length > 0) {
                    owner.authStatus = res.data[0].auth_status
                    owner.realName = res.data[0].real_name || ''
                    owner.idcard = res.data[0].idcard || ''
                } else {
                    owner.authStatus = 0
                    owner.realName = ''
                    owner.idcard = ''
                }
            } catch (e) {
                owner.authStatus = 0
            }
        },
        clearOwnerAuthByUsername(username) {
            this.$confirm('确认清除该店主的实名认证信息吗？清除后需要重新认证。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const { data: res } = await this.$http.post('storeuserinfo/boss/clearauth', {
                    username: username,
                    admin_token: this.admin_token
                })
                if (res.code == 0) {
                    this.$message.success('清除成功')
                    // 更新本地状态
                    const owner = this.dynamicValidateForm.owners.find(o => o.username === username)
                    if (owner) {
                        owner.authStatus = 0
                        owner.realName = ''
                        owner.idcard = ''
                    }
                } else {
                    this.$message.error(res.msg || '清除失败')
                }
            }).catch(() => {})
        },
        addOwner() {
            this.dynamicValidateForm.owners.push({
                username: '',
                percentage: '',
                authStatus: undefined,
                realName: '',
                idcard: '',
                key: Date.now(),
              istx: null,
              isaudit: null,
              menuList: [],
              roleList: [],
              roleKeys: []
            })
          this.filterRole()
        },
        async ChangeSub(e) {
            const confirmResult = await this.$confirm('危险操作：确定要切换商户收款吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err);

            if (confirmResult !== 'confirm') {
                if (e == "0"){
                    this.editForm.issub = "1"; // 恢复之前的状态
                }else{
                    this.editForm.issub = "0"; // 恢复之前的状态
                }
                return this.$message.info('已取消！');
            }
        },
        SettingSave(){
            this.$refs.editFormRef.validate( async valid=>{
                if (!valid) return
                const confirmResult = await this.$confirm('请再次确认收款商户！！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).catch(err => err);

                if (confirmResult !== 'confirm') {
                    return this.$message.info('已取消！');
                }
                const { data:res } = await this.$http.post('setstorepoints/',this.editForm)
                if(res.status===0)
                {
                    this.$message({message: '设置成功！',type: 'success'})
                }
                this.settingDialogVisible = false

            })
        },
        async SetMock(storeid,ismock){
            const { data:res } = await this.$http.post('setmock/',{storeid:storeid,ismock:ismock})
            if(res.status===0)
            {
                this.$message({message: '设置成功！',type: 'success'})
                this.getList()
            }
        },
        // 切换分润显示状态（门店列表页面）
        async toggleProfitDisplay(storeId, isEnabled){
            try {
                const { data: res } = await this.$http.post('/api/profit/config/toggle', {
                    storeId: storeId,
                    isEnabled: isEnabled
                })

                if(res.status === 0) {
                    this.$message({
                        message: res.message || (isEnabled === 1 ? '已开启分润显示' : '已关闭分润显示'),
                        type: 'success'
                    })
                    // 刷新列表以更新状态
                    this.getList()
                } else {
                    // 操作失败，恢复开关状态
                    this.$message({
                        message: res.message || '操作失败',
                        type: 'error'
                    })
                    // 恢复开关状态
                    this.getList()
                }
            } catch (error) {
                console.error('切换分润显示失败:', error)
                this.$message({
                    message: '操作失败：' + (error.message || '网络错误'),
                    type: 'error'
                })
                // 恢复开关状态
                this.getList()
            }
        },
        // 生成签名的函数
        async getSign(signKey, data) {
        // 排序数据键
        const sortedKeys = Object.keys(data).sort();
        let stringSign = signKey;

        // 拼接键值对
        sortedKeys.forEach((key) => {
            const value = data[key];
            if (value) {
            stringSign += key + value;
            }
        });

        // 使用SHA-1生成签名
        const encoder = new TextEncoder();
        const dataBuffer = encoder.encode(stringSign);
        const hashBuffer = await crypto.subtle.digest('SHA-1', dataBuffer);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
        return hashHex;
        },
        async SetMeiTuan(storeid,bus) {
          this.title = '美团授权'
          // ✅ 第一步：立即打开空白窗口（必须在同步上下文中！）
          const newWindow = window.open('', '_blank');
          if (!newWindow) {
            this.$message.error('请允许弹出窗口，再试一次');
            return;
          }

          const timestamp = Date.now();
          const signKey = 'u7hjmpmxc5gjognt';
          const data = {
              businessId: bus,
              charset: 'UTF-8',
              developerId: '114173',
              state:storeid,
              timestamp: timestamp,
          };

          const sign = await this.getSign(signKey, data);
          this.mtAuthUrl = `https://open-erp.meituan.com/general/auth?developerId=${data.developerId}&timestamp=${timestamp}&charset=UTF-8&businessId=${data.businessId}&sign=${sign}&state=${data.state}`;
          // ✅ 第三步：将真实 URL 赋给已打开的窗口
          newWindow.location.href = this.mtAuthUrl;
          // this.openShowMt = true
        },
        async DelMeiTuan(storeid) {
          this.title = '解除美团授权'
          // ✅ 第一步：立即打开空白窗口（必须在同步上下文中！）
          const newWindow = window.open('', '_blank');
          if (!newWindow) {
            this.$message.error('请允许弹出窗口，再试一次');
            return;
          }

          const timestamp = Date.now();
          const signKey = 'u7hjmpmxc5gjognt';
          const data = {
              businessId: '58',
              charset: 'UTF-8',
              developerId: '114173',
              state:storeid + "," + this.username,
              timestamp: timestamp,
          };

          const sign = await this.getSign(signKey, data);
          this.mtAuthUrl = `https://open-erp.meituan.com/general/unauth?developerId=${data.developerId}&timestamp=${timestamp}&charset=UTF-8&businessId=${data.businessId}&sign=${sign}&state=${data.state}`;
          // ✅ 第三步：将真实 URL 赋给已打开的窗口
          newWindow.location.href = this.mtAuthUrl;
          // this.openShowMt = true
        },
        async SetBath(){
            this.bathDialogVisible = true
            const { data:res } = await this.$http.get('setbath/')
            if(res.status===0)
            {
                this.bathlist = res.data
            }
        },
        async AddBath(){
            if(this.bath_username.trim()==''){
                this.$message.error('请输入淋浴手机号')
            }else{
                const { data:res } = await this.$http.post('addbath/',{username:this.bath_username,admin_token:this.admin_token})
                if(res.status===0){
                    this.$message({message: '设置成功！',type: 'success'})
                }else{
                    this.$message.error(res.message)
                }
                this.bath_username = ''
                this.SetBath()
            }
        },
        async DelBath(username){
            const confirmResult = await this.$confirm('确定要删除此手机号吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).catch(err => err);

            if (confirmResult !== 'confirm') {
                return this.$message.info('已取消！');
            }
            const { data:res } = await this.$http.post('delbath/',{username:username,admin_token:this.admin_token})
            if(res.status===0)
            {
                this.$message({message: '删除成功',type: 'success'})
            }
            this.SetBath()
        },
        async SetAir(storeid){
          this.gatewar = null
          this.wgType = '0'
          this.airDevice = []
          this.wgForm.storeid = storeid
          const { data: res } = await this.$http.get('getair/'+storeid)
          console.log(res)
          console.log(res.status)
          if(res.status == 0){
              this.airForm = res.data;
          }
          this.ariDialogVisible = true
          this.storeid = storeid
        },
        async SetAirNew(row){
          this.airFormNew = []
          const { data: res } = await this.$http.get('getairNew/'+row.id)
          if(res.status == 0 && res.data.length){
            let arr = res.data
            let obj = {
                path: null,
                data: []
            }
            let newArr = []
            arr.forEach(item => {
              if (!obj.path || obj.path !== item.path) {
                if (obj.path) {
                  newArr.push(obj)
                }
                obj = {
                  id: item.id,
                  path: item.path,
                  airType: item.airType,
                  data: []
                }
              }
              obj.data.push(item)
            })
            if (obj.data.length > 0) {
              newArr.push(obj)
            }
            this.airFormNew = newArr
          }
          this.ariDialogVisibleNew = true
          this.storeid = row.id
          console.log(row)
          this.topic = row.upDeviceTopic
        },
      async openDeviceStatus(row){
        this.devices = []
        const { data: res } = await this.$http.get('getNewDevice/'+row.id)
        if(res.status == 0 && res.data.length){
          this.devices = res.data
        }
        this.deviceStatusDialogVisibleNew = true
      },
      async playMusic(row){
        this.musicTopic = row.musicTopic
        this.storeId = row.id
        this.music = []
        this.musicTableLoading = true
        const { data: res } = await this.$http.get('getStoreMusic/'+row.id)
        this.musicTableLoading = false
        if(res.status == 0 && res.data.length){
          this.music = res.data
        }
        this.musicDialogVisibleNew = true
      },
      async refreshMusicOnly(){
        this.musicTableLoading = true
        const { data: res } = await this.$http.get('getStoreMusic/' + this.storeId)
        this.musicTableLoading = false
        if (res.status == 0 && res.data && res.data.length) {
          this.music = res.data
          this.$message.success('音乐库已刷新')
        } else {
          this.music = []
          this.$message.info('该门店暂无音乐数据')
        }
      },
      // 打开定时播报语音弹窗
      async playDsMusic(row){
        this.musicTopic = row.musicTopic
        this.storeId = row.id

        this.musicTableLoading = true
        this.musicCk = []
        const { data: res2 } = await this.$http.get('getMusicTemps')
        if(res2.status == 0 && res2.data.length){
          this.musicCk = res2.data
        }
        await this.getPlanList()
        this.musicPlanDialogVisibleNew = true
      },
      // 查询音乐计划
      async getPlanList() {
        this.musicPlan = []
        const { data: res } = await this.$http.post('getMusicTempPlan', {storeid: this.storeId})
        this.musicTableLoading = false
        if(res.status == 0 && res.data.length){
          this.musicPlan = res.data
        }
      },
      // 打开添加语音计划弹窗
      handleAddMusic(){
        this.restPlan()
        this.planTitle = '添加语音计划'
        this.operaMusicPlanDialogVisibleNew = true
      },
      // 打开编辑语音计划弹窗
      handleEditMusicPlan(row){
        this.restPlan()
        this.musicPlanForm = {
          ...row,
          planName: row.planName || null,
          isOpen: row.isOpen != null ? Number(row.isOpen) : 1,
          defMinute: row.defMinute != null ? Number(row.defMinute) : null,
          repeatType: row.repeatType != null ? Number(row.repeatType) : null,
          defHoursArr: row.playTime ? row.playTime.split(',').map(t => parseInt(t.split(':')[0], 10)) : [],
          weekDaysArr: row.weekDays ? row.weekDays.split(',').map(Number) : []
        }
        this.planTitle = '修改语音计划'
        this.operaMusicPlanDialogVisibleNew = true
        // 立即查询已占用小时，高亮灰色不可选
        this.fetchUsedDefHours()
      },
      // 删除语音计划
      async handleDelMusicPlan(index, id) {
        const confirmResult = await this.$confirm('确定要删除此音乐计划吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(err => err);

        if (confirmResult !== 'confirm') {
          return this.$message.info('已取消！');
        }
        const { data:res } = await this.$http.post('delMusicTempPlan',{topic: this.musicTopic, id})
        if(res.status===0)
        {
          this.musicPlan.splice(index, 1)
          this.$message({message: '删除成功',type: 'success'})
        }
      },
      // 列表切换开启/关闭
      async handleToggleMusicPlanOpen(row){
        try {
          const { data: res } = await this.$http.post('operaMusicTempPlan', { ...row, storeid: this.storeId })
          if (res.status === 0) {
            this.$message.success(row.isOpen === 1 ? '已开启' : '已关闭')
          } else {
            // 失败回退
            row.isOpen = row.isOpen === 1 ? 0 : 1
            this.$message.error(res.msg || '操作失败')
          }
        } catch (e) {
          row.isOpen = row.isOpen === 1 ? 0 : 1
          this.$message.error('操作失败')
        }
      },
      // 提交音乐计划
      submitMusicPlan(){
        this.$refs["musicPlan"].validate(valid => {
          if (valid) {
            const form = { ...this.musicPlanForm }
            form.topic = this.musicTopic
            // 小时 + 统一分钟 => 实际播放时间，如 10:30,11:30,20:30
            form.playTime = this.playTimePreview.join(',')
            form.defHour = form.defHoursArr.slice().sort((a, b) => a - b).map(h => this.pad2(h)).join(',')
            form.weekDays = form.repeatType === 2 ? form.weekDaysArr.slice().sort((a, b) => a - b).join(',') : ''
            // 分钟补零，如 0 => '00'
            form.defMinute = this.pad2(form.defMinute)
            delete form.defHoursArr
            delete form.weekDaysArr
            delete form.startTime
            delete form.endTime

            this.$http.post('operaMusicTempPlan', form).then(res => {
              let dat = res.data
              if(dat.status===0)
              {
                this.$message({message: '操作成功',type: 'success'})
              }

              this.getPlanList()
              this.operaMusicPlanDialogVisibleNew = false
            })
          }
        });
      },
      // 数字补零，如 3 => '03'
      pad2(n){
        return String(n).padStart(2, '0')
      },
      // 音乐时长（毫秒）转 分:秒，如 185000 => '03:05'
      formatMusicDuration(ms){
        if (ms === null || ms === undefined || ms === '') return '-'
        const totalSeconds = Math.floor(Number(ms) / 1000)
        if (isNaN(totalSeconds)) return '-'
        return this.pad2(Math.floor(totalSeconds / 60)) + ':' + this.pad2(totalSeconds % 60)
      },
      // 查询已被其他播放计划占用的小时（编辑时排除自身）
      async fetchUsedDefHours(){
        const m = this.musicPlanForm.defMinute
        if (m === null || m === undefined || m === '') {
          this.fetchSeq++
          this.occupiedHours = []
          return
        }
        const seq = ++this.fetchSeq
        try {
          const params = { storeid: this.storeId, defMinute: this.pad2(m) }
          if (this.musicPlanForm.id) {
            params.id = this.musicPlanForm.id
          }
          const { data: res } = await this.$http.post('musicVersion/getUsedDefHours', params)
          if (seq !== this.fetchSeq) return // 已有更新的请求，丢弃本次结果
          if (res.code === 200 && res.data) {
            this.occupiedHours = res.data.split(',')
          } else {
            this.occupiedHours = []
          }
        } catch (e) {
          console.error('查询已占用小时失败', e)
          if (seq !== this.fetchSeq) return
          this.occupiedHours = []
        }
        // 剔除与新分钟下占用冲突的已选小时，避免出现"禁用且勾选"无法取消的状态
        if (this.musicPlanForm.defHoursArr && this.musicPlanForm.defHoursArr.length) {
          this.musicPlanForm.defHoursArr = this.musicPlanForm.defHoursArr.filter(h => this.occupiedHours.indexOf(this.pad2(h)) === -1)
        }
      },
      settingTyMusic() {
        this.tyMusic = []
        this.kxMusic = []
        this.music.forEach(item => {
          if (item.is_ty == '1') {
            this.tyMusic.push(item)
          } else {
            this.kxMusic.push(item)
          }
        })
        this.tyMusicDialogVisibleNew = true
      },
      // 删除日常音乐
      handleDelTyMusic(index) {
        let obj = this.tyMusic[index]
        let jg = this.kxMusic.filter(item => item.code === obj.code)
        if (!jg) {
          this.kxMusic.push(obj)
        }
        this.tyMusic.splice(index,1)
      },
      // 添加音乐
      handleAddTyMusic() {
        this.selectMusicForm.codes = []
        this.selectMusicDialogVisibleNew = true
      },
      // 提交选择的音乐
      submitSelectMusic() {
        this.$refs["selectMusic"].validate(valid => {
          if (valid) {
            let kxMusic = []
            this.kxMusic.forEach(item => {
              if (this.selectMusicForm.codes.indexOf(item.code) > -1) {
                this.tyMusic.push(item)
              } else {
                kxMusic.push(item)
              }
            })
            this.kxMusic = kxMusic
            this.selectMusicDialogVisibleNew = false
          }
        });
      },
      // 保存日常音乐
      handleSaveTyMusic() {
        let obj = this.tyMusic.map(i => i.code)
        console.log('日常音乐：', obj)
        this.$http.post('/mqtt/settingTyMusic',{codes: this.tyMusic.map(i => i.code).join(','), topic: this.musicTopic, id: this.storeId}).then(_ => {
          this.tyMusicDialogVisibleNew = false
          this.playMusic({musicTopic: this.musicTopic, id: this.storeId})
          this.$message.success('设置成功')
        })
      },
      // 操作日常音乐
      handleOperaMusic(key) {
        this.$http.post('/mqtt/operatorMusic',{topic: this.musicTopic, key}).then(_ => {
          this.$message.success('操作成功')
        })
      },
      // 重置音乐计划表单
      restPlan(){
        this.musicPlanForm = {
          id: null,
          planName: null,
          tempId: null,
          storeid: this.storeId,
          defMinute: null,
          defHoursArr: [],
          playTime: null,
          defHour: null,
          repeatType: null,
          weekDaysArr: [],
          weekDays: null,
          isOpen: 1
        }
      },
      // 打开播放计划弹窗
      async openPlayTaskDialog(row){
        this.musicTopic = row.musicTopic
        this.storeId = row.id
        await this.getPlayTaskList()
        await this.getMusicTagCounts()
        await this.fetchMusicBoxStatus()
        this.playTaskDialogVisible = true
      },
      // 仅查询音乐盒子状态（打开弹窗时用）
      async fetchMusicBoxStatus(){
        this.musicBoxLoading = true
        try {
          const { data: res } = await this.$http.get('musicVersion/getMusicBoxStatus/' + this.storeId)
          if (res.code === 200 && res.data) {
            this.musicBoxStatus = res.data.play_status || 0
            this.musicBoxVolume = res.data.default_volume || 0
          }
        } catch (e) {
          console.error('查询音乐盒子信息失败', e)
        } finally {
          this.musicBoxLoading = false
        }
      },
      // 刷新音乐盒子信息（刷新按钮：先更新再查询）
      async refreshMusicBoxInfo(){
        this.musicBoxLoading = true
        try {
          // 先通知后端更新音乐信息
          await this.$http.post('musicVersion/toUpdateMusicInfo', { storeId: this.storeId })
          // 等待3秒后查询最新状态
          await new Promise(resolve => setTimeout(resolve, 3000))
          const { data: res } = await this.$http.get('musicVersion/getMusicBoxStatus/' + this.storeId)
          if (res.code === 200 && res.data) {
            this.musicBoxStatus = res.data.play_status || 0
            this.musicBoxVolume = res.data.default_volume || 0
          }
        } catch (e) {
          console.error('刷新音乐盒子信息失败', e)
        } finally {
          this.musicBoxLoading = false
        }
      },
      // 设置音量
      async handleSetVolume(val){
        this.musicBoxLoading = true
        try {
          const { data: res } = await this.$http.post('musicVersion/setVolume', { storeId: this.storeId, volume: val })
          if (res.code === 200) {
            this.$message.success('音量设置成功')
            this.updateMusicInfo()
          } else {
            this.$message.error(res.msg || '音量设置失败')
            await this.refreshMusicBoxInfo()
          }
        } catch (e) {
          this.$message.error('音量设置失败')
          await this.refreshMusicBoxInfo()
        } finally {
          this.musicBoxLoading = false
        }
      },
      // 设置音乐盒子开关
      async handleSetPlayStatus(val){
        this.musicBoxLoading = true
        try {
          const { data: res } = await this.$http.post('musicVersion/setPlayStatus', { storeId: this.storeId, status: val })
          if (res.code === 200) {
            this.$message.success(val === 1 ? '音乐盒子已开启' : '音乐盒子已关闭')
            this.updateMusicInfo()
          } else {
            this.$message.error(res.msg || '操作失败')
            await this.refreshMusicBoxInfo()
          }
        } catch (e) {
          this.$message.error('操作失败')
          await this.refreshMusicBoxInfo()
        } finally {
          this.musicBoxLoading = false
        }
      },
      // 通知后端更新音乐信息
      async updateMusicInfo(){
        try {
          await this.$http.post('musicVersion/toUpdateMusicInfo', { storeId: this.storeId })
        } catch (e) {
          console.error('更新音乐信息失败', e)
        }
      },
      // 查询门店播放任务列表
      async getPlayTaskList(){
        this.playTaskList = []
        const { data: res } = await this.$http.get('musicPlayTask/list/' + this.storeId)
        if (res.status === 0 && res.data && res.data.length) {
          this.playTaskList = res.data
        }
      },
      // 查询门店下各种音乐分类（music_tag）的数量
      async getMusicTagCounts(){
        this.musicTagOptions = []
        const { data: res } = await this.$http.get('musicVersion/musicTagCounts/' + this.storeId)
        if (res.status === 0 && res.data && res.data.length) {
          this.musicTagOptions = res.data
        }
      },
      // 播放类型名称
      playTypeName(type){
        const map = { 1: '顺序', 2: '随机', 3: '列表循环' }
        return map[type] || '未知'
      },
      // 播放类型标签样式
      playTypeTagType(type){
        const map = { 1: 'success', 2: 'warning', 3: 'primary' }
        return map[type] || 'info'
      },
      // 打开新增播放任务弹窗
      handleAddPlayTask(){
        this.restPlayTask()
        this.playTaskTitle = '新增播放任务'
        this.playTaskOperaDialogVisible = true
      },
      // 打开修改播放任务弹窗
      async handleEditPlayTask(row){
        this.restPlayTask()
        const { data: res } = await this.$http.get('musicPlayTask/' + row.id)
        if (res.status === 0 && res.data) {
          const item = res.data
          this.playTaskForm = {
            id: item.id,
            storeId: item.storeId || this.storeId,
            taskName: item.taskName,
            startTime: item.startTime,
            endTime: item.endTime,
            playTags: item.playTags,
            playType: item.playType
          }
          this.playTagsArr = item.playTags ? item.playTags.split(',') : []
        } else {
          this.playTaskForm = {
            id: row.id,
            storeId: this.storeId,
            taskName: row.taskName,
            startTime: row.startTime,
            endTime: row.endTime,
            playTags: row.playTags,
            playType: row.playType
          }
          this.playTagsArr = row.playTags ? row.playTags.split(',') : []
        }
        this.playTaskTitle = '修改播放任务'
        this.playTaskOperaDialogVisible = true
      },
      // 删除播放任务
      handleDelPlayTask(index, id){
        this.$confirm('确定要删除此播放任务吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post('musicPlayTask/delete/' + id).then(res => {
            const dat = res.data
            if (dat.status === 0) {
              this.playTaskList.splice(index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            } else {
              this.$message({ message: dat.msg || '删除失败', type: 'error' })
            }
          }).catch(() => {
            this.$message({ message: '删除失败', type: 'error' })
          })
        }).catch(() => {})
      },
      // 重置播放任务表单
      restPlayTask(){
        this.playTagsArr = []
        this.playTaskForm = {
          id: null,
          storeId: this.storeId,
          taskName: '',
          startTime: null,
          endTime: null,
          playTags: '',
          playType: 1
        }
      },
      // 提交播放任务（新增/修改）
      submitPlayTask(){
        this.$refs['playTaskForm'].validate(valid => {
          if (!valid) return
          this.playTaskForm.storeId = this.storeId
          this.playTaskForm.playTags = this.playTagsArr.join(',')
          const url = this.playTaskForm.id ? 'musicPlayTask/update' : 'musicPlayTask/add'
          this.btnLoading = true
          this.$http.post(url, this.playTaskForm).then(res => {
            this.btnLoading = false
            const dat = res.data
            if (dat.status === 0) {
              this.$message({ message: '操作成功', type: 'success' })
              this.playTaskOperaDialogVisible = false
              this.getPlayTaskList()
            } else {
              this.$message({ message: dat.msg || '操作失败', type: 'error' })
            }
          }).catch(() => {
            this.btnLoading = false
          })
        })
      },

      addAirManager() {
          this.airFormNew.push({
            path: null,
            airType: '1',
            data: [
              {
                storeId: this.storeid,
                name: null,
                ifPp: 'Y',
                openFlag: 'N',
                autoFlag: '1',
                autoType: '1',
                dsTimeArr: null
              }
            ]
          })
      },
      handleDelAirManager(index) {
        this.airFormNew.splice(index, 1)
      },
      addAir(index) {
        if (this.airFormNew[index].data.length < 4 || this.airFormNew[index].airType === '2') {
          this.airFormNew[index].data.push({
            storeId: this.storeid,
            port: null,
            name: null,
            ifPp: 'N',
            openFlag: 'N',
            autoFlag: '1',
            autoType: '1',
            dsTimeArr: null
          })
        } else {
          this.$message.error('一个控制器设备最多添加4个');
        }
      },
      delAir(index, airIndex) {
        this.airFormNew[index].data.splice(airIndex, 1)
      },
      async submitAirFormNew() {
        this.btnLoading = true
        let sign = 0
        let arr = []
        this.airFormNew.forEach((item, ki) => {
          if (!item.path) {
            sign = 1
          }
          if (item.data.length > 0) {
            item.data.forEach((sub, i) => {
              if (!sub.port) {
                if (item.airType === '0') {
                  sign = 2
                } else if (item.airType === '2') {
                  sign = 5
                }
              }
              if (!sub.name) {
                sub.name = '空调' + (ki + 1) + '-' + (i + 1)
              }
              sub.path = item.path
              sub.airType = item.airType

              if (sub.autoType === '0') {
                if (!sub.startTime) {
                  sign = 4
                } else {
                  let date
                  if (this.isDate(sub.startTime)) {
                    date = sub.startTime
                  } else {
                    date = new Date(sub.startTime)
                  }
                  sub.startTimeL = date.getTime()
                  sub.startTime = null
                }
                if (!sub.endTime) {
                  sign = 6
                } else {
                  let date
                  if (this.isDate(sub.endTime)) {
                    date = sub.endTime
                  } else {
                    date = new Date(sub.endTime)
                  }
                  sub.endTimeL = date.getTime()
                  sub.endTime = null
                }
              }
              arr.push(sub)
            })
          } else {
            sign = 3
          }
        })

        if (sign == 1) {
          this.$message.error('控制器地址不可为空');
          this.btnLoading = false
          return
        } else if (sign == 2) {
          this.$message.error('设备端口不可为空');
          this.btnLoading = false
          return
        } else if (sign == 5) {
          this.$message.error('内机地址不可为空');
          this.btnLoading = false
          return
        } else if (sign == 3) {
          this.$message.error('控制器下不可无设备');
          this.btnLoading = false
          return
        } else if (sign == 4) {
          this.$message.error('继电器定时开启不可以不设置开启时间！');
          this.btnLoading = false
          return
        } else if (sign == 6) {
          this.$message.error('继电器定时开启不可以不设置关闭时间！');
          this.btnLoading = false
          return
        }

        const { data: res } = await this.$http.post('setairNew',{storeid:this.storeid,airs:arr, topic: this.topic})
        if(res.status == 0){
          this.$message({message: '设置成功！',type: 'success'})
          this.ariDialogVisibleNew = false
        }
        this.btnLoading = false
      },
      isDate(value) {
        return Object.prototype.toString.call(value) === '[object Date]';
      },
      handleAlterPath(index, subIndex) {
          if (subIndex != null) {
            let sub = this.airFormNew[index].data[subIndex];
            sub.ifPp = 'N'
            sub.openFlag = 'N'
            this.$set(this.airFormNew[index].data,subIndex, sub)
          } else {
            this.airFormNew[index].data.forEach((sub, i) => {
              sub.ifPp = 'N'
              sub.openFlag = 'N'
              this.$set(this.airFormNew[index].data,i, sub)
            })
          }
      },
      handleZPath(index, subIndex) {
        let data = this.airFormNew[index].data
        let path =  data[subIndex].port
        if (path) {
          if (path.length < 4) {
            this.$message({message: '内机地址不可小于4位！',type: 'error'})
            path = null
          }

          if (path) {
            let fhz = data.filter(item => item.port === path)
            if (fhz && fhz.length > 1) {
              path = null
              this.$message({message: '内机地址不可重复！',type: 'error'})
            }
          }

          data[subIndex].port = path
          data[subIndex].ifPp = 'N'
          this.$set(data,subIndex, data[subIndex])
        }
      },
      async ppAir(index, subIndex) {
        if (this.topic) {
          const loading = this.$loading({
            lock: true,
            text: '匹配命令发送中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.airManagerIndex = index
          this.airIndex = subIndex

          const { data: res } = await this.$http.post('mqtt/operatorAir',{port:this.airFormNew[index].data[subIndex].port,path:this.airFormNew[index].path,command: 'pp',topic:this.topic,  airType: '0'})
          if (res.status == 0){
            this.$confirm('匹配是否完成?', '提示', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              type: 'warning'
            }).then(() => {
              this.ariOperatorDialogVisibleNew = true
            });
          } else {
            this.$message.error('发送失败');
          }
          loading.close()
        } else {
          this.$message.warning('未添加上位机TOPIC,请添加后再次匹配');
        }
      },
      async operatorAir(val) {
        const loading = this.$loading({
          lock: true,
          text: '匹配命令发送中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        const { data: res } = await this.$http.post('mqtt/operatorAir',{ port:this.airFormNew[this.airManagerIndex].data[this.airIndex].port,
          path:this.airFormNew[this.airManagerIndex].path,command: val,topic:this.topic, airType: '0'})
        if (res.status != 0){
          this.$message.error('发送失败');
        } else {
          let obj = this.airFormNew[this.airManagerIndex].data[this.airIndex]
          obj.openFlag = val === 'open' ? 'Y' : 'N'
          this.$set(this.airFormNew[this.airManagerIndex].data,this.airIndex, obj)
        }
        loading.close()
      },
      alterAirFormNew(){
        let obj = this.airFormNew[this.airManagerIndex].data[this.airIndex]
        obj.ifPp = 'Y'
        this.$set(this.airFormNew[this.airManagerIndex].data,this.airIndex, obj)
        this.ariOperatorDialogVisibleNew = false
      },
      handleAutoChange(row, index, subIndex) {
        if (row.autoFlag === '0') {
          row.autoType = null
        } else {
          row.autoType = '1'
        }
        row.dsTimeArr = null

        this.$set(this.airFormNew[index].data[subIndex], row)
      },
      handleAutoTypeChange(row, index, subIndex){
        if (row.autoType === '1') {
          row.startTime = null
          row.endTime = null
        }
        this.$set(this.airFormNew[index].data[subIndex], row)
      },
      handleAirTypeChange(row, index) {
        if (row.airType === '1') {
          row.data = [
            {
              storeId: this.storeid,
              name: null,
              ifPp: 'N',
              openFlag: 'N',
              autoFlag: '1',
              autoType: '1',
              dsTimeArr: null
            }
          ]
        } else {
          row.data = []
        }
        this.$set(this.airFormNew[index], row)
      },

      // 打开设置开卡时间弹窗
      openShareSetting(row) {
        this.shareSettingForm.storeId = row.id
        this.shareSettingForm.storeName = row.storename
        this.shareSettingForm.shareEnabled = row.shareEnabled || 0
        this.shareSettingForm.shareRewardDays = row.shareRewardDays || 1
        this.shareSettingDialogVisible = true
      },

      submitShareSetting() {
        this.btnLoading = true
        this.$http.post('store/update-share-setting', {
          id: this.shareSettingForm.storeId,
          shareEnabled: this.shareSettingForm.shareEnabled,
          shareRewardDays: this.shareSettingForm.shareRewardDays
        }).then(({ data: res }) => {
          this.btnLoading = false
          if (res.status === 0) {
            this.$message.success('设置成功')
            this.shareSettingDialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.msg || '设置失败')
          }
        }).catch(() => {
          this.btnLoading = false
          this.$message.error('请求失败，请稍后重试')
        })
      },

      openCardDays(storeId) {
        this.openCardForm.storeId = storeId
        this.openCardForm.openCardDays = 0 // 默认值
        this.openCardDialogVisible = true
      },

      // 提交开卡时间设置
      submitOpenCardDays() {
        if (this.openCardForm.openCardDays === null || this.openCardForm.openCardDays === '') {
          this.$message.error('请输入开卡时间')
          return
        }

        this.btnLoading = true
        this.$http.post('store/update-open-card-days', {
          id: this.openCardForm.storeId,
          openCardDays: this.openCardForm.openCardDays
        }).then(({ data: res }) => {
          this.btnLoading = false
          if (res.status === 0) {
            this.$message.success('设置成功')
            this.openCardDialogVisible = false
            this.getList() // 刷新列表
          } else {
            this.$message.error(res.msg || '设置失败')
          }
        }).catch(() => {
          this.btnLoading = false
          this.$message.error('请求失败，请稍后重试')
        })
      },

      // 店主管理相关方法
      openStoreOwnerManager() {
        this.role = null
        this.storeOwnerManagerVisible = true
        this.resetManagerForm()
        this.loadAllStores()
      },

      closeStoreOwnerManager() {
        this.storeOwnerManagerVisible = false
        this.resetManagerForm()
      },

      resetManagerForm() {
        this.managerForm.phone = ''
        this.ownerStoresList = []
        this.checkedStores = []
        this.checkAll = false
        this.isIndeterminate = false
        this.storeSearchText = ''
        this.storeStatusFilter = ''
        this.allStoreOwners = {}
      },

      async searchOwnerStores() {
        if (!this.managerForm.phone.trim()) {
          this.$message.error('请输入手机号')
          return
        }

        this.searchStore = null

        this.searchLoading = true
        try {
          const { data: res } = await this.$http.get('/api/v2/store-owner/search-by-phone', {
            params: { username: this.managerForm.phone }
          })

          if (res.status === 0) {
            this.ownerStoresList = res.data || []
            // 自动选中已关联的门店
            this.checkedStores = this.ownerStoresList.map(store => store.id)
            this.handleCheckedStoresChange(this.checkedStores)
          } else {
            this.ownerStoresList = []
          }
          this.handleSearchOwnerStore()
        } catch (error) {
          console.error('查询店主门店失败:', error)
          this.$message.error('查询失败，请稍后重试')
          this.ownerStoresList = []
        } finally {
          this.searchLoading = false
        }
      },

      async removeOwnerAssociation(store) {
        const confirmResult = await this.$confirm(
          `确定要删除手机号 ${this.managerForm.phone} 与门店 "${store.storename}" 的关联吗？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch(err => err)

        if (confirmResult !== 'confirm') {
          return this.$message.info('已取消删除')
        }

        try {
          const { data: res } = await this.$http.post('/api/v2/store-owner/remove-association', {
            phone: this.managerForm.phone,
            storeid: store.id,
            userId: store.userId,
            admin_token: this.admin_token
          })

          if (res.status === 0) {
            this.$message.success('删除关联成功')
            // 重新查询
            this.searchOwnerStores()
          } else {
            this.$message.error(res.message || '删除失败')
          }
        } catch (error) {
          console.error('删除店主关联失败:', error)
          this.$message.error('删除失败，请稍后重试')
        }
      },

      // 清除店主实名信息
      clearOwnerAuth() {
        this.$confirm('确认清除该店主的实名认证信息吗？清除后需要重新认证。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const { data: res } = await this.$http.post('storeuserinfo/boss/clearauth', {
            username: this.managerForm.phone,
            admin_token: this.admin_token
          });
          if (res.code == 0) {
            this.$message.success('清除成功');
            this.searchOwnerStores();
          } else {
            this.$message.error(res.msg || '清除失败');
          }
        }).catch(() => {});
      },

      maskAuthName(name) {
        if (!name || name.length <= 1) return name || '--'
        return name.charAt(0) + '*'.repeat(name.length - 1)
      },

      maskAuthIdCard(idCard) {
        if (!idCard || idCard.length < 8) return idCard || '--'
        return idCard.substring(0, 3) + '***********' + idCard.substring(idCard.length - 4)
      },

      async loadAllStores() {
        this.storesLoading = true
        try {
          const { data: res } = await this.$http.get('/api/v2/store-owner/stores')

          if (res.status === 0) {
            this.allStoresList = res.data || []
            // 加载所有门店的店主信息
            await this.loadAllStoreOwners()
          } else {
            this.$message.error(res.message || '加载门店列表失败')
            this.allStoresList = []
          }
        } catch (error) {
          console.error('加载门店列表失败:', error)
          this.$message.error('加载失败，请稍后重试')
          this.allStoresList = []
        } finally {
          this.storesLoading = false
        }
      },

      async loadAllStoreOwners() {
        // 这里可以调用一个API获取所有门店的店主信息，暂时用空对象
        this.allStoreOwners = {}
      },

      handleCheckAllChange(val) {
        this.checkedStores = val ? this.filteredStores.map(store => store.id) : []
        this.isIndeterminate = false
      },

      handleCheckedStoresChange(value) {
        let checkedCount = value.length
        this.checkAll = checkedCount === this.filteredStores.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.filteredStores.length
      },

      async submitStoreOwnerChanges() {
        if (!this.managerForm.phone.trim()) {
          this.$message.error('请输入店主手机号')
          return
        }

        if (this.checkedStores.length === 0) {
          this.$message.error('请至少选择一个门店')
          return
        }

        if (!this.role) {
          this.$message.error('请选择角色')
          return
        }

        let roleObj = this.roles.filter(item => item.roleKey === this.role)[0]

        const confirmResult = await this.$confirm(
          `确定要将手机号 ${this.managerForm.phone} 设置为 ${this.checkedStores.length} 个门店的${roleObj.roleName}吗？`,
          '确认设置',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch(err => err)

        if (confirmResult !== 'confirm') {
          return this.$message.info('已取消设置')
        }

        this.submitLoading = true
        try {
          const { data: res } = await this.$http.post('/api/v2/store-owner/batch-set', {
            phone: this.managerForm.phone,
            storeIds: this.checkedStores,
            bobi: '0', // 固定传0，后端不使用此字段
            admin_token: this.admin_token,
            role: this.role
          })

          if (res.status === 0) {
            this.$message.success('店主设置成功')
            this.closeStoreOwnerManager()
          } else {
            this.$message.error(res.message || '设置失败')
          }
        } catch (error) {
          console.error('设置店主失败:', error)
          this.$message.error('设置失败，请稍后重试')
        } finally {
          this.submitLoading = false
        }
      },
      handleTopicBlur() {
        if (this.wgForm.gateway) {
          this.wgForm.gateway = this.wgForm.gateway.replace(new RegExp(':', "g"), '')
        }
      },
      submitWgForm() {
        this.$refs["wgForm"].validate(valid => {
          if (valid) {
            this.btnLoading = true
            this.$http.post('/setairWg/', this.wgForm).then(res => {
              if (res.data.status === 0) {
                this.$http.get('getair/'+this.wgForm.storeid).then(res => {
                  if(res.data.status == 0){
                    this.airForm = res.data.data;
                    this.wgAddFlag = false
                    this.btnLoading = false
                  }
                })
                this.$message.success('添加成功')
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        });
      },
      submitAirDevForm() {
        this.$refs["airDevForm"].validate(valid => {
          if (valid) {
            this.btnLoading = true
            this.$http.post('/setAirDev/', this.airDevForm).then(res => {
              if (res.data.status === 0) {
                this.btnLoading = false
                this.airDevAddFlag = false
                this.handleWgClick({
                  type: this.wgType,
                  gateway: this.airDevForm.gateway
                })
                this.$message.success('添加成功')
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        });
      },
      handleAddWg() {
        this.wgForm.type = '0'
        this.wgForm.gateway = null
        this.wgAddFlag = true
      },
      handleAddAirDevice() {
        this.airDevForm.gateway = this.gatewar
        this.airDevForm.far = null
        this.airDevForm.storeid = this.storeid
        this.airDevAddFlag = true
      },
      async handleDelWg(id) {
        const { data: res } = await this.$http.get('/delairWg/' + id)
        if (res.status === 0) {
          this.gatewar = null
          this.wgType = '0'
          this.$message.success('删除成功')
        }
        await this.SetAir(this.storeid)
      },
      async handleDelDevice(id) {
        const { data: res } = await this.$http.get('/delairAirDev/' + id)
        if (res.status === 0) {
          this.$message.success('删除成功')
        }
        await this.handleWgClick({
          type: this.wgType,
          gateway: this.gatewar
        })
      },
      /** 商用网关添加设备操作按钮操作 */
      handleAddDevice(id) {
        let that = this
        this.$confirm('是否确认为当前网关匹配设备？').then(function() {
          // eslint-disable-next-line no-unused-vars
          that.$http.get('/addWgDevice/' + id).then(_ => {
            that.$message.success('请重置设备（设备闪灯计进入配对模式），网关会自动添加设备')
          })
        });
      },
      handleWgClick(row){
        this.wgType = row.type
        this.gatewar = row.gateway
        const loading = this.$loading({
          lock: true,
          text: '获取数据中。。。',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$http.get('getairDevice/'+row.gateway).then(res => {
          if(res.data.status == '0'){
            this.airDevice = res.data.data;
            loading.close()
          }
        })
      },
      async handlePpDevice(row) {
        this.ppForm.ppMethod = '1'
        this.ppForm.brand = null
        this.ppForm.gateway = row.gateway
        this.ppForm.far = row.far
        this.ppForm.id = row.id
        this.ppRules.brand = [
          { required: true, message: "品牌不能为空", trigger: "blur" },
        ]
        const {data: res} = await this.$http.get('getBrand/')
        this.brandArr = res.data

        this.openPp = true
      },
      // 匹配设备品牌变更事件
      handleBrandChange(val) {
        this.kfidArr = []
        this.ppForm.brand = null
        if (val) {
          let arr = val.split('-')
          this.kfidIndex = 0
          if (arr.minMatchCharLength === 1) {
            this.kfidArr = arr
          } else {
            for (let i = parseInt(arr[0]); i <= parseInt(arr[1]); i++) {
              this.kfidArr.push(i)
            }
          }
          this.kfid = this.kfidArr[0]
          this.ppForm.brand = this.brandArr.filter(item => item.kfid === val)[0].brand
        }
      },
      handlePpMethodChange(val) {
        this.ppRules.brand = []
        if (val == '1') {
          this.ppRules.brand = [
            { required: true, message: "品牌不能为空", trigger: "blur" },
          ]
        }
      },
      subMitPpForm() {
        this.$refs["formPp"].validate(valid => {
          if (valid) {
            if (this.ppForm.ppMethod === '0') {
              this.ppForm.type = this.wgType
              this.$http.post('/ppAirDevice/', this.ppForm).then(res => {
                if (res.data.status == '0') {
                  const loading = this.$loading({
                    lock: true,
                    text: '自动匹配中，将遥控对准红外传感器按开机按钮，等待10秒后刷新页面如果成功会变更匹配状态',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  });
                  setTimeout(() => {
                    loading.close();
                    this.handleWgClick({
                      type: this.wgType,
                      gateway: this.ppForm.gateway
                    })
                    this.openSdPp = false
                  }, 10000);
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.isExec = false,
              this.openSdPp = true
            }
          }
        });
      },
      // 下一个序号
      nextBrand(){
        if (this.kfidIndex < this.kfidArr.length) {
          if (this.isExec) {
            this.kfidIndex++
            this.kfid = this.kfidArr[this.kfidIndex]
          } else {
            let that = this
            this.$confirm('当前品牌设备未进行操作确定切换下一个么？').then(function() {
              that.kfidIndex++
              that.kfid = that.kfidArr[this.kfidIndex]
            });
          }
        } else {
          this.$message.warning("已是当前品牌设备最后一个")
        }
      },
      async openDevice(openFlag) {
        let that = this
        let obj = {...this.ppForm}
        obj.openFlag = openFlag
        obj.kfid = this.kfid
        obj.type = this.wgType
        const {data:res} = await this.$http.post('/sdPpAirDevice/', obj)
        if (res.status == '0') {
          that.isExec = true;
          this.$confirm('当前设备是否有反应？').then(function() {
            that.$http.get('/updateAir/' + obj.id)
            that.handleWgClick({
              type: that.wgType,
              gateway: obj.gateway
            })
            that.$message.success("设置成功");
            that.openSdPp = false
            that.openPp = false
          })
        } else {
          this.$message.error(res.msg)
        }
      },
      handleDelUser(index) {
        this.dynamicValidateTxForm.users.splice(index, 1)
      },
      handleAddUser() {
        this.dynamicValidateTxForm.users.push({
          username: null,
          istx: '1',
          isaudit: '1',
          acountId: this.dynamicValidateTxForm.id,
          storeId: this.dynamicValidateTxForm.storeId
        })
      },

      // 设置门店状态筛选
      setStoreStatusFilter(status) {
        this.storeStatusFilter = status
      },
      handlePlayMusic(row, cd) {
        let that = this
        this.$confirm('是否确认点播当前音乐？').then(function() {
          that.$http.post('/mqtt/operatorPlayMusic',{code: row.code, topic: that.musicTopic, cd}).then(_ => {
            that.$message.success('点播成功，等待音乐播放')
          })
        });
      },
      handleSyncMusic() {
        let that = this
        this.$confirm('是否确认同步音乐库？').then(function() {
          that.$http.post('/mqtt/operatorSyncMusic',{topic: that.musicTopic}).then(_ => {
            that.$message.success('同步成功，请刷新查看信息')
          })
        });
      },

      // 打开延长会员卡天数对话框
      openExtendCardsDialog(row) {
        this.extendCardsForm.storeId = row.id
        this.extendCardsForm.storeName = row.storename
        this.extendCardsForm.days = 30
        this.extendCardsDialogVisible = true
      },

      // 提交延长会员卡天数
      async submitExtendCards() {
        this.$refs.extendCardsFormRef.validate(async (valid) => {
          if (!valid) {
            return
          }

          try {
            const confirmResult = await this.$confirm(
              `确认要为【${this.extendCardsForm.storeName}】的所有有效会员卡延长 ${this.extendCardsForm.days} 天吗？`,
              '确认操作',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }
            ).catch(() => 'cancel')

            if (confirmResult === 'cancel') {
              return
            }

            this.extendCardsLoading = true

            const { data: res } = await this.$http.post('/store/extend-cards', {
              storeId: this.extendCardsForm.storeId,
              days: this.extendCardsForm.days
            })

            this.extendCardsLoading = false

            if (res.status === 0 || res.code === 200) {
              const message = res.data.skippedCount > 0
                ? `操作成功！共延长了 ${res.data.affectedCount} 张会员卡的有效期（跳过 ${res.data.skippedCount} 张无效卡）`
                : `操作成功！共延长了 ${res.data.affectedCount} 张会员卡的有效期`
              this.$message.success(message)
              this.extendCardsDialogVisible = false
            } else {
              this.$message.error(res.data?.message || res.message || '操作失败')
            }
          } catch (error) {
            this.extendCardsLoading = false
            console.error('延长会员卡天数失败:', error)
            this.$message.error('操作失败：' + (error.message || '未知错误'))
          }
        })
      },
      // 锁定门店
      async lockStore(storeId) {
        try {
          const confirmResult = await this.$confirm('锁定后门店将在7天后自动下架，确定要锁定该门店吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).catch(() => 'cancel')

          if (confirmResult === 'cancel') return

          const { data: res } = await this.$http.post('api/store/lock', { storeId })

          if (res.code === 200 || res.status === 0) {
            this.$message.success(res.data || res.msg || '锁定成功')
            await this.getList() // 刷新列表
          } else {
            this.$message.error(res.data || res.msg || '锁定失败')
          }
        } catch (error) {
          console.error('锁定门店失败:', error)
          this.$message.error('操作失败: ' + (error.message || '未知错误'))
        }
      },
      // 解锁门店
      async unlockStore(storeId) {
        try {
          const confirmResult = await this.$confirm('确定要解锁该门店吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).catch(() => 'cancel')

          if (confirmResult === 'cancel') return

          const { data: res } = await this.$http.post('api/store/unlock', { storeId })

          if (res.code === 200 || res.status === 0) {
            this.$message.success(res.data || res.msg || '解锁成功')
            await this.getList() // 刷新列表
          } else {
            this.$message.error(res.data || res.msg || '解锁失败')
          }
        } catch (error) {
          console.error('解锁门店失败:', error)
          this.$message.error('操作失败: ' + (error.message || '未知错误'))
        }
      },
      filterRole(flag) {
        let ownNum = this.dynamicValidateForm.owners.filter(item => item.roleKeys.includes("STORE_OWNER")).length
        let managNum = this.dynamicValidateForm.owners.filter(item => item.roleKeys.includes("STORE_MANAGER")).length
        let dyNum = this.dynamicValidateForm.owners.filter(item => item.roleKeys.includes("STORE_ASSOCIATE")).length
        let bjNum = this.dynamicValidateForm.owners.filter(item => item.roleKeys.includes("CLEANER")).length

        this.dynamicValidateForm.owners.forEach(owner => {
          // 角色过滤
          let roles = []
          let menus = []
          let xz
          this.roleList.forEach(item => {
            switch (item.roleKey) {
              case 'STORE_OWNER':
                xz = 1;
                if (this.deptRoleXz.ownerNum) {
                  xz = this.deptRoleXz.ownerNum
                }
                if (ownNum < xz || owner.roleKeys.includes(item.roleKey)) {
                  roles.push(item)
                }
                break
              case 'STORE_MANAGER':
                xz = 3;
                if (this.deptRoleXz.managerNum) {
                  xz = this.deptRoleXz.managerNum
                }
                if (managNum < xz || owner.roleKeys.includes(item.roleKey)) {
                  roles.push(item)
                }
                break
              case 'STORE_ASSOCIATE':
                xz = 3;
                if (this.deptRoleXz.associateNum) {
                  xz = this.deptRoleXz.associateNum
                }
                if (dyNum < xz || owner.roleKeys.includes(item.roleKey)) {
                  roles.push(item)
                }
                break
              case 'CLEANER':
                xz = 3;
                if (this.deptRoleXz.clearNum) {
                  xz = this.deptRoleXz.clearNum
                }
                if (bjNum < xz || owner.roleKeys.includes(item.roleKey)) {
                  roles.push(item)
                }
                break
              default:
                roles.push(item)
            }
            if (owner.roleKeys.includes(item.roleKey)) {
              menus = menus.concat(item.permissionList)
            }
          })
          owner.roleList = roles
          owner.menuList = [...new Set(menus)]
          if (flag != 'init') {
            if (owner.menuList.indexOf('tx') > -1) {
              owner.istx = '1'
              owner.isaudit = '1'
            } else {
              owner.istx = null
              owner.isaudit = null
            }
          }
        })
      },
      handleSearchOwnerStore() {
        if (this.searchStore) {
          const searchLower = this.searchStore.toLowerCase().replaceAll(" ", "");
          if (searchLower) {
            this.filterOwnerStoresList = this.ownerStoresList.filter(item => {
              // 店铺名称搜索
              return item.storename && item.storename.toLowerCase().indexOf(searchLower) >= 0;
            });
          } else {
            this.filterOwnerStoresList = this.ownerStoresList
          }
        } else {
          this.filterOwnerStoresList = this.ownerStoresList
        }
      }
    },

    computed: {
      // 过滤后的门店列表（根据搜索文本和状态）
      filteredStores() {
        let stores = this.allStoresList

        // 按状态筛选
        if (this.storeStatusFilter) {
          stores = stores.filter(store => String(store.isopen) === String(this.storeStatusFilter))
        }

        // 按搜索文本筛选
        if (this.storeSearchText && this.storeSearchText.trim()) {
          const searchText = this.storeSearchText.toLowerCase()
          stores = stores.filter(store => {
            return (store.storename && store.storename.toLowerCase().includes(searchText)) ||
                   (store.address && store.address.toLowerCase().includes(searchText)) ||
                   (store.telephone && store.telephone.toLowerCase().includes(searchText))
          })
        }

        return stores
      },
      // 从关联门店列表中提取实名认证信息
      ownerAuthInfo() {
        if (this.ownerStoresList.length === 0) return {}
        const first = this.ownerStoresList[0]
        return {
          authStatus: first.auth_status,
          realName: first.real_name,
          idcard: first.idcard
        }
      },
      // 结束时间选项（每小时的 59 分：00:59, 01:59 ... 23:59）
      endTimeOptions() {
        const options = []
        for (let h = 0; h < 24; h++) {
          const t = String(h).padStart(2, '0') + ':59'
          if (!this.playTaskForm.startTime || t >= this.playTaskForm.startTime) {
            options.push(t)
          }
        }
        return options
      },
      // 播放时间预览：所选小时 + 统一分钟 => 00:30、01:30、10:30
      playTimePreview() {
        const m = this.musicPlanForm.defMinute
        if (m === null || m === undefined) return []
        const mm = this.pad2(m)
        return (this.musicPlanForm.defHoursArr || []).slice().sort((a, b) => a - b).map(h => this.pad2(h) + ':' + mm)
      }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .plan-time-tip {
        color: #909399;
        font-size: 12px;
        line-height: 18px;
        margin-bottom: 6px;
    }
    .hour-checkbox {
        margin-left: 0;
        margin-right: 0;
        width: calc(100% / 12);
        box-sizing: border-box;
        padding-right: 8px;
    }
    .hour-checkbox >>> .el-checkbox__label {
        padding-left: 4px;
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    .el-table::before {
    height: 0px;
    }

    /* 店主管理对话框样式 */
    .store-owner-dialog {
      border-radius: 8px;
    }

    .store-owner-dialog .el-dialog {
      max-height: 90vh;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .store-owner-dialog .el-dialog__body {
      flex: 1;
      overflow: hidden;
      padding: 20px;
      background-color: #fafbfc;
    }

    .store-owner-dialog .el-dialog__header {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      border-radius: 8px 8px 0 0;
      padding: 20px 24px;
    }

    .store-owner-dialog .el-dialog__title {
      color: white;
      font-weight: 600;
      font-size: 18px;
    }

    .store-owner-dialog .el-dialog__headerbtn .el-dialog__close {
      color: white;
      font-size: 20px;
    }

    .store-owner-dialog .el-dialog__body {
      padding: 24px;
      background-color: #fafbfc;
    }

    .manager-container {
      display: flex;
      gap: 20px;
      min-height: 55vh;
      max-height: 60vh;
    }

    .left-panel {
      flex: 1;
      min-width: 380px;
    }

    .right-panel {
      flex: 2;
      min-width: 520px;
    }

    .search-card, .stores-card {
      height: 100%;
      border-radius: 12px;
      border: 1px solid #e8eaed;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
      display: flex;
      flex-direction: column;
    }

    .search-card .el-card__body {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 20px;
    }

    .search-form-section {
      flex-shrink: 0;
    }

    .search-card .el-card__header,
    .stores-card .el-card__header {
      background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
      border-bottom: 1px solid #e8eaed;
      border-radius: 12px 12px 0 0;
      padding: 16px 20px;
    }

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 600;
      color: #2c3e50;
      font-size: 16px;
    }

    .header-left {
      display: flex;
      align-items: center;
    }

    .header-right {
      display: flex;
      align-items: center;
    }

    .load-stores-btn {
      background: linear-gradient(135deg, #ff9a56 0%, #ff6b35 100%);
      border: none;
      color: white;
      font-weight: 500;
      padding: 8px 16px;
      border-radius: 6px;
      box-shadow: 0 2px 8px rgba(255, 107, 53, 0.3);
      transition: all 0.3s ease;
    }

    .load-stores-btn:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
    }

    .card-header i {
      margin-right: 10px;
      font-size: 18px;
      color: #409EFF;
    }

    /* 实名认证信息卡片 */
    .auth-info-section {
      margin-top: 20px;
    }

    .auth-info-card {
      background: #fff;
      border-radius: 10px;
      border: 1px solid #e8eaed;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      overflow: hidden;
    }

    .auth-info-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 16px;
      background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
      border-bottom: 1px solid #e8eaed;
      font-weight: 600;
      color: #2c3e50;
      font-size: 14px;
    }

    .auth-header-left {
      display: flex;
      align-items: center;
    }

    .auth-header-left i {
      margin-right: 8px;
      font-size: 16px;
      color: #409EFF;
    }

    .auth-header-left .el-tag {
      margin-left: 12px;
    }

    .auth-info-body {
      padding: 14px 16px;
    }

    .auth-info-row {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .auth-info-item {
      display: flex;
      align-items: center;
    }

    .auth-label {
      color: #909399;
      font-size: 13px;
      margin-right: 10px;
      white-space: nowrap;
      width: 56px;
      text-align: right;
    }

    .auth-value {
      color: #303133;
      font-size: 14px;
      font-family: 'Courier New', monospace;
      letter-spacing: 1px;
    }

    .clear-auth-btn {
      color: #f56c6c;
      font-size: 13px;
      padding: 4px 12px;
      transition: all 0.3s;
    }

    .clear-auth-btn:hover {
      background-color: #fef0f0;
      border-radius: 4px;
    }

    /* 旧版设置店主弹窗 - 店主行样式 */
    .owner-row {
      width: 100%;
    }

    .owner-main-line {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .owner-phone-input {
      width: 220px;
    }

    .owner-auth-line {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 8px;
      padding-left: 4px;
    }

    .owner-auth-chip {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 4px 12px;
      background: #f0f9eb;
      border: 1px solid #c2e7b0;
      border-radius: 6px;
      font-size: 12px;
      white-space: nowrap;
    }

    .auth-chip-label {
      color: #909399;
    }

    .auth-chip-value {
      color: #303133;
      font-family: 'Courier New', monospace;
      font-weight: 500;
    }

    .auth-chip-divider {
      color: #dcdfe6;
      margin: 0 2px;
    }

    .owner-delete-btn {
      color: #f56c6c;
      font-size: 13px;
      padding: 4px 12px;
      transition: all 0.3s;
    }

    .owner-delete-btn:hover {
      background-color: #fef0f0;
      border-radius: 4px;
    }

    .associated-stores {
      margin-top: 16px;
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }

    .section-title {
      display: flex;
      align-items: center;
      font-weight: 600;
      color: #409EFF;
      margin-bottom: 12px;
      font-size: 15px;
      padding: 8px 12px;
      background-color: #f0f9ff;
      border-radius: 6px;
      border-left: 4px solid #409EFF;
    }

    .section-title i {
      margin-right: 8px;
      font-size: 16px;
    }

    .associated-table-container {
      flex: 1;
      overflow-y: auto;
      border-radius: 8px;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
      min-height: 200px;
      max-height: 400px;
    }

    .associated-table-container::-webkit-scrollbar {
      width: 6px;
    }

    .associated-table-container::-webkit-scrollbar-track {
      background: #f8f9fa;
      border-radius: 3px;
    }

    .associated-table-container::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 3px;
    }

    .associated-table-container::-webkit-scrollbar-thumb:hover {
      background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
    }

    .associated-table {
      border-radius: 8px;
      overflow: hidden;
    }

    .associated-table .el-table__header {
      background-color: #f8f9fa;
    }

    .remove-btn {
      color: #f56c6c;
      transition: all 0.3s;
    }

    .remove-btn:hover {
      color: #f56c6c;
      background-color: #fef0f0;
      transform: scale(1.1);
    }

    .no-data {
      text-align: center;
      padding: 60px 20px;
      color: #909399;
      font-size: 15px;
      background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
      border-radius: 12px;
      margin: 20px 0;
    }

    .no-data i {
      font-size: 56px;
      display: block;
      margin-bottom: 16px;
      opacity: 0.6;
      color: #e6a23c;
    }

    .select-controls {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      padding: 12px 16px;
      background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
      color: white;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(240, 147, 251, 0.3);
    }

    .select-controls .el-checkbox__label {
      color: white;
      font-weight: 500;
    }

    .selected-count {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.9);
      font-weight: 500;
    }

    .stores-list {
      max-height: 35vh;
      overflow-y: auto;
      padding: 10px;
      background-color: white;
      border-radius: 8px;
      border: 1px solid #e8eaed;
    }

    .stores-list::-webkit-scrollbar {
      width: 6px;
    }

    .stores-list::-webkit-scrollbar-track {
      background: #f8f9fa;
      border-radius: 3px;
    }

    .stores-list::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 3px;
    }

    .stores-list::-webkit-scrollbar-thumb:hover {
      background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
    }

    .store-card {
      margin-bottom: 10px;
      border: 2px solid #e8eaed;
      border-radius: 8px;
      padding: 12px;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      transition: all 0.3s ease;
      cursor: pointer;
    }

    .store-card:hover {
      border-color: #409EFF;
      box-shadow: 0 4px 16px rgba(64, 158, 255, 0.15);
      transform: translateY(-2px);
    }

    .store-card.selected {
      border-color: #409EFF;
      background: linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%);
      box-shadow: 0 4px 16px rgba(64, 158, 255, 0.2);
    }

    .store-checkbox {
      width: 100%;
    }

    .store-checkbox .el-checkbox__label {
      width: 100%;
      padding-left: 8px;
    }

    .store-content {
      width: 100%;
    }

    .store-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
    }

    .store-name {
      font-weight: 600;
      color: #2c3e50;
      font-size: 15px;
      flex: 1;
    }

    .store-id {
      margin-left: 12px;
      background-color: #409EFF;
      color: white;
      border: none;
    }

    .store-address {
      font-size: 13px;
      color: #606266;
      margin-bottom: 6px;
      line-height: 1.4;
    }

    .store-phone {
      font-size: 12px;
      color: #909399;
      display: flex;
      align-items: center;
    }

    .store-phone i {
      margin-right: 4px;
      color: #67c23a;
    }

    .store-profit-switch {
      margin-top: 10px;
      padding-top: 8px;
      border-top: 1px solid #e8eaed;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .store-profit-switch .switch-label {
      font-size: 13px;
      color: #606266;
      font-weight: 500;
    }

    .dialog-footer {
      padding: 16px 20px;
      background-color: #fafbfc;
      border-top: 1px solid #e8eaed;
      border-radius: 0 0 8px 8px;
      position: sticky;
      bottom: 0;
      z-index: 100;
      box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    }

    .footer-info {
      margin-bottom: 16px;
    }

    .summary-card {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px 24px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      border-radius: 8px;
      font-size: 15px;
      font-weight: 500;
      box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
    }

    .summary-card i {
      margin-right: 12px;
      font-size: 18px;
    }

    .footer-buttons {
      text-align: center;
      display: flex;
      justify-content: center;
      gap: 16px;
    }

    .footer-buttons .el-button {
      padding: 12px 32px;
      font-size: 14px;
      font-weight: 500;
      border-radius: 6px;
      min-width: 120px;
    }

    .input-with-select{
      margin-bottom: 10px;
    }
</style>
